var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _text, _text2, _text3, _g8, _g9, _g10, _line, _line2, _circle, _g11, _path, _path2, _path3, _path4, _path5, _path6, _g12, _path7, _path8, _g13, _path9, _g14, _path10, _g15, _path11, _path12, _polygon, _path13, _path14, _polygon2, _rect, _g16, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _g17, _polygon9, _rect2, _g18, _path15, _path16, _polygon10, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g19, _g20, _g21, _path29, _path30, _mask, _circle2, _path31, _path32, _path33, _path34, _path35, _path36, _g22, _path37, _ellipse, _path38, _g23, _clipPath, _path39, _ellipse2, _path40, _image, _g24, _g25, _g26, _g27, _g28;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "eZ2eP1AIHkg1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 1920 1080",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "eZ2eP1AIHkg8-filter",
  x: "-150%",
  width: "400%",
  y: "-150%",
  height: "400%"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  id: "eZ2eP1AIHkg8-filter-grayscale-0",
  type: "matrix",
  values: "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0",
  result: "result"
})), /*#__PURE__*/React.createElement("filter", {
  id: "eZ2eP1AIHkg26-filter",
  x: "-150%",
  width: "400%",
  y: "-150%",
  height: "400%"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  id: "eZ2eP1AIHkg26-filter-grayscale-0",
  type: "matrix",
  values: "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0",
  result: "result"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg278-fill",
  x1: 0.742407,
  y1: 0.937314,
  x2: 0.257593,
  y2: 0.062686,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg278-fill-0",
  offset: "0%",
  stopColor: "#5432fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg278-fill-1",
  offset: "100%",
  stopColor: "#2575fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg285-fill",
  x1: 530.1752,
  y1: 601.3462,
  x2: 572.1182,
  y2: 664.642,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-0",
  offset: "1%",
  stopColor: "#e89f97"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-1",
  offset: "30%",
  stopColor: "#e69c96"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-2",
  offset: "47%",
  stopColor: "#de9492"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-3",
  offset: "62%",
  stopColor: "#d1868c"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-4",
  offset: "75%",
  stopColor: "#be7183"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-5",
  offset: "87%",
  stopColor: "#a65778"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-6",
  offset: "98%",
  stopColor: "#88376a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg285-fill-7",
  offset: "100%",
  stopColor: "#823067"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg302-fill",
  x1: 124.9,
  y1: 326.04,
  x2: 124.9,
  y2: 677.69,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg302-fill-0",
  offset: "0%",
  stopColor: "rgba(37,117,252,0.99)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg302-fill-1",
  offset: "100%",
  stopColor: "#5432fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg320-fill",
  x1: 255.68,
  y1: 497.28,
  x2: 257.49,
  y2: 668.57,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-0",
  offset: "0%",
  stopColor: "#14243a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-1",
  offset: "19%",
  stopColor: "#14243e"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-2",
  offset: "36%",
  stopColor: "#162449"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-3",
  offset: "53%",
  stopColor: "#17255c"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-4",
  offset: "70%",
  stopColor: "#1a2677"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-5",
  offset: "87%",
  stopColor: "#1e2799"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg320-fill-6",
  offset: "100%",
  stopColor: "#2128ba"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg324-fill",
  x1: 255.68,
  y1: 497.28,
  x2: 257.49,
  y2: 668.57,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-1",
  offset: "14%",
  stopColor: "#fbfbfb"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-2",
  offset: "26%",
  stopColor: "#f0f0f0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-3",
  offset: "39%",
  stopColor: "#ddd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-4",
  offset: "51%",
  stopColor: "#c2c2c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-5",
  offset: "63%",
  stopColor: "#a0a0a0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-6",
  offset: "75%",
  stopColor: "#767676"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-7",
  offset: "86%",
  stopColor: "#444"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-8",
  offset: "98%",
  stopColor: "#0b0b0b"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg324-fill-9",
  offset: "100%",
  stopColor: "#000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg329-fill",
  x1: 295.2788,
  y1: 617.1452,
  x2: 310.0588,
  y2: 616.554,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg329-fill-0",
  offset: "1%",
  stopColor: "#cf5988"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg329-fill-1",
  offset: "100%",
  stopColor: "#e897b9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg330-fill",
  x1: 442.53061,
  y1: 609.268037,
  x2: 499.033322,
  y2: 660.483567,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-0",
  offset: "1%",
  stopColor: "#e89f97"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-1",
  offset: "30%",
  stopColor: "#e69c96"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-2",
  offset: "47%",
  stopColor: "#de9492"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-3",
  offset: "62%",
  stopColor: "#d1868c"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-4",
  offset: "75%",
  stopColor: "#be7183"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-5",
  offset: "87%",
  stopColor: "#a65778"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-6",
  offset: "98%",
  stopColor: "#88376a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg330-fill-7",
  offset: "100%",
  stopColor: "#823067"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg345-fill",
  x1: 214.1608,
  y1: 524.036,
  x2: 299.0308,
  y2: 520.6412,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg345-fill-0",
  offset: "0%",
  stopColor: "#2b34f0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg345-fill-1",
  offset: "100%",
  stopColor: "#4786f0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg349-fill",
  x1: 214.1608,
  y1: 524.036,
  x2: 299.0308,
  y2: 520.6412,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg349-fill-0",
  offset: "0%",
  stopColor: "#000"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg349-fill-1",
  offset: "100%",
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg360-fill",
  x1: 664.48,
  y1: 571.85,
  x2: 726.64,
  y2: 696.18,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg360-fill-0",
  offset: "0%",
  stopColor: "#2b34f0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg360-fill-1",
  offset: "100%",
  stopColor: "#14243a"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg364-fill",
  x1: 664.48,
  y1: 571.85,
  x2: 726.64,
  y2: 696.18,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg364-fill-0",
  offset: "0%",
  stopColor: "#000"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg364-fill-1",
  offset: "100%",
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg365-fill",
  x1: 120.74,
  y1: 607.07,
  x2: 190.74,
  y2: 607.07,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg365-fill-0",
  offset: "0%",
  stopColor: "#171c85"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg365-fill-1",
  offset: "100%",
  stopColor: "#2b34f0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg369-fill",
  x1: 123.74,
  y1: 548.28,
  x2: 187.74,
  y2: 548.28,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg369-fill-0",
  offset: "0%",
  stopColor: "#ffac60"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg369-fill-1",
  offset: "100%",
  stopColor: "#d16400"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg373-fill",
  x1: 124.3,
  y1: 567.53,
  x2: 191.79,
  y2: 567.53,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-0",
  offset: "0%",
  stopColor: "#14243a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-1",
  offset: "16%",
  stopColor: "#15243e"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-2",
  offset: "31%",
  stopColor: "#162449"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-3",
  offset: "46%",
  stopColor: "#19245c"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-4",
  offset: "61%",
  stopColor: "#1c2477"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-5",
  offset: "75%",
  stopColor: "#212399"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-6",
  offset: "89%",
  stopColor: "#2723c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg373-fill-7",
  offset: "100%",
  stopColor: "#2c23e7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg377-fill",
  x1: 124.3,
  y1: 567.53,
  x2: 191.79,
  y2: 567.53,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-1",
  offset: "14%",
  stopColor: "#fbfbfb"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-2",
  offset: "26%",
  stopColor: "#f0f0f0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-3",
  offset: "39%",
  stopColor: "#ddd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-4",
  offset: "51%",
  stopColor: "#c2c2c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-5",
  offset: "63%",
  stopColor: "#a0a0a0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-6",
  offset: "75%",
  stopColor: "#767676"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-7",
  offset: "86%",
  stopColor: "#444"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-8",
  offset: "98%",
  stopColor: "#0b0b0b"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg377-fill-9",
  offset: "100%",
  stopColor: "#000"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg382-fill",
  x1: 130.43,
  y1: 639.67,
  x2: 184.76,
  y2: 639.67,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-0",
  offset: "0%",
  stopColor: "#14243a"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-1",
  offset: "16%",
  stopColor: "#15243e"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-2",
  offset: "31%",
  stopColor: "#162449"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-3",
  offset: "46%",
  stopColor: "#19245c"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-4",
  offset: "61%",
  stopColor: "#1c2477"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-5",
  offset: "75%",
  stopColor: "#212399"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-6",
  offset: "89%",
  stopColor: "#2723c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg382-fill-7",
  offset: "100%",
  stopColor: "#2c23e7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg386-fill",
  x1: 130.43,
  y1: 639.67,
  x2: 184.76,
  y2: 639.67,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-1",
  offset: "14%",
  stopColor: "#fbfbfb"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-2",
  offset: "26%",
  stopColor: "#f0f0f0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-3",
  offset: "39%",
  stopColor: "#ddd"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-4",
  offset: "51%",
  stopColor: "#c2c2c2"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-5",
  offset: "63%",
  stopColor: "#a0a0a0"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-6",
  offset: "75%",
  stopColor: "#767676"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-7",
  offset: "86%",
  stopColor: "#444"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-8",
  offset: "98%",
  stopColor: "#0b0b0b"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg386-fill-9",
  offset: "100%",
  stopColor: "#000"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg506-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg506-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg506-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg506-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg506-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg506-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg507-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg507-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg507-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg507-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg507-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg507-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg508-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg508-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg508-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg508-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg508-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg508-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg509-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg509-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg509-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg509-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg509-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg509-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg510-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg510-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg510-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg510-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg510-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg510-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg511-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg511-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg511-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg511-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg511-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg511-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg512-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg512-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg512-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg512-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg512-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg512-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg513-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg513-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg513-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg513-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg513-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg513-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg514-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg514-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg514-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg514-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg514-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg514-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg515-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg515-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg515-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg515-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg515-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg515-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg516-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg516-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg516-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg516-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg516-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg516-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg517-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg517-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg517-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg517-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg517-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg517-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "eZ2eP1AIHkg518-fill",
  cx: 0,
  cy: 0,
  r: 0.5,
  spreadMethod: "pad",
  gradientUnits: "objectBoundingBox",
  gradientTransform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg518-fill-0",
  offset: "0%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg518-fill-1",
  offset: "32%",
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg518-fill-2",
  offset: "44%",
  stopColor: "rgba(255,255,255,0.7389041095890411)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg518-fill-3",
  offset: "78%",
  stopColor: "rgba(255,255,255,0.23)"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg518-fill-4",
  offset: "100%",
  stopColor: "rgba(255,255,255,0)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg534-fill",
  x1: -0.03,
  y1: 48.95,
  x2: 10.79,
  y2: 48.95,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg534-fill-0",
  offset: "0%",
  stopColor: "#2575fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg534-fill-1",
  offset: "100%",
  stopColor: "#5432fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg536-fill",
  x1: 0,
  y1: 60.25,
  x2: 9.58,
  y2: 60.25,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg536-fill-0",
  offset: "0%",
  stopColor: "#5432fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg536-fill-1",
  offset: "100%",
  stopColor: "#2575fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg538-fill",
  x1: 131.9,
  y1: 97.27,
  x2: 131.9,
  y2: 3.19,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg538-fill-0",
  offset: "0%",
  stopColor: "#5432fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg538-fill-1",
  offset: "100%",
  stopColor: "#2575fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg553-fill",
  x1: -0.03,
  y1: 48.95,
  x2: 10.79,
  y2: 48.95,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg553-fill-0",
  offset: "0%",
  stopColor: "#2575fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg553-fill-1",
  offset: "100%",
  stopColor: "#5432fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg555-fill",
  x1: 0,
  y1: 60.25,
  x2: 9.58,
  y2: 60.25,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg555-fill-0",
  offset: "0%",
  stopColor: "#5432fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg555-fill-1",
  offset: "100%",
  stopColor: "#2575fc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "eZ2eP1AIHkg557-fill",
  x1: 131.9,
  y1: 97.27,
  x2: 131.9,
  y2: 3.19,
  spreadMethod: "pad",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg557-fill-0",
  offset: "0%",
  stopColor: "#5432fc"
}), /*#__PURE__*/React.createElement("stop", {
  id: "eZ2eP1AIHkg557-fill-1",
  offset: "100%",
  stopColor: "#2575fc"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.806517 5.686768)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.051373 0 0 1.051373 11.794391-38.26316)",
  clipPath: "url(#eZ2eP1AIHkg39)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.037366 0 0 1.037366-25.87136 197.891886)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg11",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(408.337643 604.955815)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(415.810101 768.446776)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Coding Interview Patterns"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg15",
  transform: "translate(4.584385 0)"
}, /*#__PURE__*/React.createElement("image", {
  id: "eZ2eP1AIHkg16",
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(883.490745 604.955815)",
  opacity: 0.55
}), /*#__PURE__*/React.createElement("text", {
  id: "eZ2eP1AIHkg17",
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(953.056334 788.618075)",
  opacity: 0.55,
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Interviews")), /*#__PURE__*/React.createElement("text", {
  id: "eZ2eP1AIHkg19",
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(909.591201 768.446777)",
  opacity: 0.55,
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Recursion for Coding"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg21",
  transform: "translate(-472.169502 0)",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(1121.23951 604.955815)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1139.567764 768.446777)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Dynamic Programming"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg33",
  transform: "translate(-233.458281 0)",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1433.741497 788.618075)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Interview")), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1397.182785 768.446777)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Bitwise for Coding")), /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(1358.988273 604.955815)"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg39"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-19.831797,0h822.652814v328.547907h-822.652814v-328.547907Z",
  transform: "matrix(1.294925 0 0 0.791361 387.609589 775.12051)",
  fill: "#d2dbed",
  strokeWidth: 0
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.051373 0 0 1.051373 38.613728-23.891076)",
  clipPath: "url(#eZ2eP1AIHkg64)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.037366 0 0 1.037366 0.12864 167.740276)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-64.5-122.669999)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg44"
}, /*#__PURE__*/React.createElement("image", {
  id: "eZ2eP1AIHkg45",
  width: 200,
  height: 112,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "matrix(1.15 0 0 1.15 423.954669 81.895416)",
  opacity: 0.55
}), /*#__PURE__*/React.createElement("text", {
  id: "eZ2eP1AIHkg46",
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(482.48604 270.388403)",
  opacity: 0.55,
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Programming")), /*#__PURE__*/React.createElement("text", {
  id: "eZ2eP1AIHkg48",
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(475.876105 248.383349)",
  opacity: 0.55,
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Introduction to"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 38,
  fontWeight: 500,
  strokeWidth: 0
}))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg51",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 200,
  height: 112,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "matrix(1.15 0 0 1.15 661.933363 81.895416)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(712.157065 247.703879)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "C Programming"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg55",
  transform: "translate(-237.470747 0)",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(1137.890752 81.895416)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1222.832305 247.703882)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Python"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg59",
  transform: "translate(-237.469507 0)",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 200,
  height: 112,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "matrix(1.15 0 0 1.15 1375.869446 81.895416)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1381.881911 247.703887)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Problem Solving Beginners"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 19,
  fontWeight: 500,
  strokeWidth: 0
}))))), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg64",
  transform: "translate(0 3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-27.22746,0h781.916527v354.68h-781.916527v-354.68Z",
  transform: "matrix(1.362388 0 0 0.791361 372.274209 61.476812)",
  fill: "#d2dbed",
  strokeWidth: 0
})))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.051373 0 0 1.051373 48.099668-19.717507)",
  clipPath: "url(#eZ2eP1AIHkg84)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.037366 0 0 1.037366-288.87136 228.455744)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg68",
  transform: "translate(-238.01662 0)",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(868.066602 233.699999)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(873.973876 402.258955)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Advanced Data Structures"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg72",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(1344.090628 233.700003)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1393.217176 402.258966)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Data Structures"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg76",
  transform: "translate(238.015435 0)",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(630.054589 233.699999)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(638.19196 402.258954)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Time Complexity Analysis"))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg80",
  opacity: 0.55
}, /*#__PURE__*/React.createElement("image", {
  width: 230,
  height: 128.8,
  xlinkHref: "data:image/jpeg;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(1106.078615 233.699999)"
}), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 19,
  fontWeight: 500,
  transform: "translate(1180.058271 402.258955)",
  fill: "#212121",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 500,
  strokeWidth: 0
}, "Algorithms")))), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg84"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-0.680138,0h734.548732v360.570167h-734.548732L-0.680138,0Z",
  transform: "matrix(1.398448 0 0 0.791361 355.25089 397.760038)",
  fill: "#d2dbed",
  strokeWidth: 0
})))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg99)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1.03009 0 0 1-3.13415 0)"
}, /*#__PURE__*/React.createElement("line", {
  id: "eZ2eP1AIHkg88",
  x1: 1640.92,
  y1: 902.1,
  x2: 1329.8,
  y2: 902.1,
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: 10
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg89",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg90",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg91",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg92",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg93",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg94",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg95",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg96",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg97",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg98",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1389.8 902.1)",
  fill: "#2575fc",
  strokeWidth: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg99"
}, /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg100",
  d: "M5,0h124.528784v224.995595h-124.528784L5,0Z",
  transform: "matrix(.915451 0 0 1 1459.453696 800.51472)",
  fill: "#d2dbed",
  strokeWidth: 0
})))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg120)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.299988-.155243)"
}, /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg103",
  d: "M1338.6,176.87l215.15.54c100.723412.237088,182.250279,81.956309,182.25,182.68v0c0,48.452401-19.247641,94.920317-53.508662,129.181338s-80.728937,53.508662-129.181338,53.508662h-206.91",
  transform: "translate(-70 1)",
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDashoffset: 6,
  strokeDasharray: 12
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg104",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg105",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg106",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg107",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg108",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg109",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg110",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg111",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg112",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg113",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg114",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg115",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg116",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg117",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg118",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg119",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(1268.6 177.87)",
  fill: "#fc903f",
  strokeWidth: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg120"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1451.298519,682.106058v-276.933666-76.951048-263.370856h308.314186v617.255569l-308.314186.000001Z",
  transform: "translate(11 0)",
  fill: "none",
  stroke: "#3f5787",
  strokeWidth: 3.84
})))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg141)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.769989-.880218)"
}, /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg124",
  d: "M603.34,540.1h-235.92c-100.204257.016567-181.425524,81.255742-181.42,181.46v0c.005521,100.196448,81.223553,181.423434,181.42,181.44h238.12",
  transform: "translate(47 1)",
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDasharray: 12
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg125",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg126",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg127",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg128",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg129",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg130",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg131",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg132",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg133",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg134",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg135",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg136",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg137",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(511.563529 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg139",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg140",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(650.34 541.1)",
  fill: "#785cff",
  strokeWidth: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg141"
}, /*#__PURE__*/React.createElement("path", {
  d: "M456.184164,1039.237209v-260.818316-70.561659-287.70898h-331.374164v619.088953l331.374164.000002Z",
  transform: "translate(-23 0.000002)",
  fill: "none",
  strokeWidth: 3.84
})))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg210)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  id: "eZ2eP1AIHkg145",
  x1: 403.084257,
  y1: 177.680005,
  x2: 112.39,
  y2: 177.68,
  transform: "translate(200.255743 0.000001)",
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: 10
}), /*#__PURE__*/React.createElement("line", {
  id: "eZ2eP1AIHkg146",
  x1: 312.360003,
  y1: 177.680004,
  x2: 144.39,
  y2: 177.68,
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: 10
}), /*#__PURE__*/React.createElement("line", {
  id: "eZ2eP1AIHkg147",
  x1: 134.39,
  y1: 282.81,
  x2: 312.36,
  y2: 179.31,
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: 10
}), /*#__PURE__*/React.createElement("line", {
  id: "eZ2eP1AIHkg148",
  x1: 135.39,
  y1: 72.56,
  x2: 312.36,
  y2: 179.31,
  fill: "none",
  stroke: "#bab8c5",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeDasharray: 10
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg149",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg150",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg151",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg152",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg153",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg154",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg155",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg156",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg157",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg158",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg161",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg162",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(312.360003 177.680004)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg163",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg164",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg165",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg166",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg167",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg168",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg169",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg170",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg171",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg172",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(144.39 177.68)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg173",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg174",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg175",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg176",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg177",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg178",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg179",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg180",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg181",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg182",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg183",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg184",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 72.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg185",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg186",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg187",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg188",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg189",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg205",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg206",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg207",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg208",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg209",
  rx: 6.660424,
  ry: 6.660424,
  transform: "translate(135.39 282.56)",
  fill: "#afcdff",
  strokeWidth: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg210"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,0h431v348.781402h-431L0,0Z",
  transform: "translate(0 18.265782)",
  fill: "#d2dbed",
  strokeWidth: 0
})))), _text || (_text = /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 18,
  fontWeight: 400,
  transform: "translate(20.09 176.025394)",
  fill: "#212121"
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 400
}, "Non Tech"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 18,
  fontWeight: 400
}, "Learners"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 36,
  fontWeight: 400
}))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 18,
  fontWeight: 400,
  transform: "translate(20.09 271.53)",
  fill: "#212121"
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 400
}, "Computer"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 18,
  fontWeight: 400
}, "Science"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 36,
  fontWeight: 400
}, "Students"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 54,
  fontWeight: 400
}))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Lato",
  fontSize: 18,
  fontWeight: 400,
  transform: "translate(20.691795 70.48)",
  fill: "#212121"
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 400
}, "Absolute"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 18,
  fontWeight: 400
}, "Beginners"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 105)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M138.75,110.34c-14.214479-.016532-25.733468-11.535521-25.75-25.75v-23c.276398-14.026323,11.725954-25.252482,25.755-25.252482s25.478602,11.226159,25.755,25.252482v23c-.022039,14.216096-11.543896,25.73348-25.76,25.75Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.75,37.69c13.206747-.000001,23.914479,10.703254,23.92,23.91v23c.000001,6.343059-2.520454,12.426177-7.006612,16.91046s-10.570329,7.002193-16.913388,6.99954v0c-13.205128,0-23.91-10.704872-23.91-23.91v-23c.005518-13.202842,10.707158-23.904482,23.91-23.91v0m0-3.68c-15.228402.02203-27.56797,12.361598-27.59,27.59v23c0,15.237536,12.352464,27.59,27.59,27.59s27.59-12.352464,27.59-27.59v-23c-.011023-15.234587-12.355418-27.583457-27.59-27.6Z",
  fill: "#9797ed"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg227",
  transform: "translate(0 0.000001)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M125.37,76.52c0,0,1.43,3.81,4.36,4.23s3.54-8.17,7.46-9.23s11.63.78,12.51,1.13.78-.49,2.15-.25s2.34,1.6,4.38.83s4-3,1.75-6.09-7.87-10.37-15.33-12.14-9.29,1-9.79,2.78c-.338732.961663-.062085,2.032681.7,2.71-2.352576-.790562-4.923672-.606913-7.14.51-3.64,1.88-3.88,8.17-2.38,12s1.33,3.52,1.33,3.52Z",
  transform: "translate(0 0.000004)",
  fill: "#9797ed"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.75,84.82c1.553729,4.652272,6.118802,7.61127,11,7.13c8.73-.55,10.76-8.28,11.06-12.86s-.51-6.55-1.11-7.12c-.770099-.916958-1.274952-2.026944-1.46-3.21-1-.07-3,.57-5.68-.32-1.618802-.534936-3.153957-1.29578-4.56-2.26-1.103036,1.230266-2.47065,2.194434-4,2.82-1.690316.734153-3.463173,1.261309-5.28,1.57s1.4.77,1.6,4.13c.182392,1.53159.108038,3.082875-.22,4.59s-.4-4.75-4.28-4.36-5.1,4.59-3.77,8s4.73,2.91,6.7,1.89Z",
  fill: "#fac08f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.67,83.09c-.853245,1.814376-2.833893,2.812953-4.8,2.42-3.37-.71-4.18-6.31-2.42-8.71s6.18-3.87,7.69,2.44c0,0,1.62-9.31-3-8.93c4.0228.270635,7.947676-1.317742,10.65-4.31-.593187-.369827-1.123246-.832363-1.57-1.37c3.095019,3.231589,7.585031,4.72826,12,4c.941979-.135556,1.871609-.346227,2.78-.63",
  transform: "translate(.000004 0.000004)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.22,68.59c0,0,.11,3.72,5.22,4.74c2.66.53,7.27-2.24,1.78-8.71s-14.38-12.89-21.22-9.44c-3.86,2.2-1.45,5.31-1.45,5.31-2.259129-.771004-4.72936-.634764-6.89.38-6.38,3.11-1.85,14.63-1.85,14.63",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.34,72.65c0,0,.84,5.5.08,9.33s-3.2,9.4-11.17,9.94c-7,.48-10.84-6.06-10.5-7.55",
  transform: "translate(.000003 0.000003)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg233",
  d: "M135.85,74.49c0,0-.22,2.06,1.24,2s1.45-1.4,1.45-2",
  transform: "translate(.000004 0)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg234",
  d: "M145.17,73.86c0,0-.22,2.06,1.24,2s1.45-1.39,1.45-2",
  transform: "translate(.000004 0)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg235",
  d: "M144,80.72c-.372989-.680721-1.093979-1.097122-1.87-1.08-.806144-.000337-1.558139.40574-2,1.08",
  transform: "translate(-.070854 0.99749)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.42,77.78c1.264301.393816,1.977289,1.730669,1.6,3-.12.57-.53.48-.53.48",
  transform: "translate(0 0.000004)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 105)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M138.75,215.4c-14.216096-.022039-25.73348-11.543896-25.75-25.76v-23c-.183703-9.322346,4.684599-18.01625,12.728761-22.73126s18.008315-4.715011,26.052478,0s12.912464,13.408914,12.728761,22.73126v23c-.016532,14.220002-11.539998,25.743468-25.76,25.76Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.75,142.74c6.343978,0,12.428124,2.520136,16.913994,7.006006s7.006006,10.570016,7.006006,16.913994v23c0,6.343978-2.520136,12.428124-7.006006,16.913994s-10.570016,7.006006-16.913994,7.006006v0c-13.206746-.005521-23.910001-10.713253-23.91-23.92v-23c-.000001-13.206747,10.703254-23.914479,23.91-23.92v0m0-3.67c-15.228402.02203-27.56797,12.361598-27.59,27.59v23c0,15.237536,12.352464,27.59,27.59,27.59s27.59-12.352464,27.59-27.59v-23c-.016534-15.230682-12.359318-27.573466-27.59-27.59Z",
  fill: "#ffac60"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg240",
  transform: "translate(.000001 0.000001)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M141.51,188.08c-.25,2.21-.31,6.16-.31,6.16l3.1.06.81-2l.93,3.11l3.22-.75-.06-1.92.81.74l1.63-.06-.73-7.75.55-.75c-.622901-1.959649-1.087723-3.966074-1.39-6l.72-4.18c6.64-3.05,4.83-9,.67-13.43-5.59-5.9-16.46-1.32-22-.45s-6.76,7.63-4.84,18.12-.43,17-.43,17c.821386,1.10648,2.093822,1.788535,3.47,1.86l1.93-.44l3.16-.49v-3.6l1.3.25.63-2-.32-.25c.32.25,2.11-.31,2.11-.31-2.23-4.84-3-19.82-3-19.82s1.82-3.59,1.42-6.53c.576893.785015,1.287794,1.462064,2.1,2c2.620665,1.65783,5.537777,2.792074,8.59,3.34s4.85.56,5,1c.145641,1.157645.219116,2.32323.22,3.49",
  fill: "#ffac60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150,174.8v0l.06,3.85c.302572,2.03387.767388,4.040272,1.39,6l-.55.74.73,7.76-1.63.06-.81-.74.06,1.92-3.22.74-.93-3.1-.81,2-3.1-.06c0,0,.06-4,.31-6.16l-1.63-3.39",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M135.39,187.51l-3.81-3.59-.2-17l5.92-2.64l12.84,3.35.43,3.38c0,0,1.07,7.44-1.45,12.17-1.89,3.54-5.36,4.54-7.61,4.9-2.056235.301927-4.15489.106464-6.12-.57Z",
  fill: "#ffebd2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M124.2,196c.821386,1.10648,2.093822,1.788535,3.47,1.86l1.93-.44l3.16-.49v-3.6l1.3.25.63-2-.32-.25c.32.25,2.11-.31,2.11-.31-2.23-4.84-3-19.82-3-19.82l.08-.17c-.6-2-2-6.58-2.91-10.37-.39.08-.77.16-1.13.21-5.52.87-6.76,7.63-4.84,18.12s-.48,17.01-.48,17.01Zm10.16-4.66v0Zm-.05,0v0Z",
  fill: "#ffac60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.57,171c0,0,1.07,7.44-1.45,12.17-1.89,3.54-5.36,4.54-7.61,4.9-2.056235.301927-4.15489.106464-6.12-.57",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.64,172.23c0,0-.16-1.7-4.13-1.94s-11.54-2.48-12.78-6.41c0,0,1.36,6.45-3.35,9.26l-2.56-3.51l3.91-7.86L144.12,160l9,8.56Z",
  fill: "#ffac60"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.64,172.23c0,0-.16-1.7-4.13-1.94s-11.54-2.48-12.78-6.41c0,0,1.36,6.45-3.35,9.26",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 2.42,
  ry: 3.2,
  transform: "translate(129.16 178.39)",
  fill: "#fff",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.66,179.13c0,0,.59-1.52-.84-2",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  id: "eZ2eP1AIHkg250",
  r: 0.7,
  transform: "translate(148.42 174.8)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("circle", {
  id: "eZ2eP1AIHkg251",
  r: 0.7,
  transform: "translate(140.81 173.68)",
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg252",
  d: "M144.12,177.4c0,0,1.24-1.37,2.85.28",
  transform: "translate(0 2)",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.79,174.8c6-2.92,4.77-9.09.67-13.43-5.59-5.9-16.46-1.32-22-.45s-6.76,7.63-4.84,18.12-.43,17-.43,17c.821386,1.10648,2.093822,1.788535,3.47,1.86l1.93-.44l3.16-.49v-3.6l1.3.25.63-2-.32-.25c.32.25,2.11-.31,2.11-.31-2.23-4.84-3-19.81-3-19.81m.93,20.12v0Zm-.05,0v0Z",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg254",
  d: "M-5.626252,0C-5.626252,-3.107293,0,-12.626252,0,-12.626252s5.626252,9.518959,5.626252,12.626252-2.518959,5.626252-5.626252,5.626252-5.626252-2.518959-5.626252-5.626252Z",
  transform: "matrix(.51 0 0 0.51 136.567799 173.976223)",
  opacity: 0,
  fill: "#b8cfff",
  stroke: "#333",
  strokeWidth: 2,
  strokeMiterlimit: 5
})))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0-209.999999)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M138.75,320.45c-14.214479-.016532-25.733468-11.535521-25.75-25.75v-23c.276398-14.026323,11.725954-25.252482,25.755-25.252482s25.478602,11.226159,25.755,25.252482v23c-.022039,14.216096-11.543896,25.73348-25.76,25.75Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.75,247.8c6.343059-.002653,12.42723,2.515258,16.913388,6.99954s7.006613,10.567401,7.006612,16.91046v23c.000001,6.343059-2.520454,12.426177-7.006612,16.91046s-10.570329,7.002193-16.913388,6.99954v0c-6.341326,0-12.422928-2.519082-16.906923-7.003077s-7.003077-10.565597-7.003077-16.906923v-23c0-13.205129,10.704872-23.91,23.91-23.91v0m0-3.68c-15.228402.02203-27.56797,12.361598-27.59,27.59v23c0,15.237536,12.352464,27.59,27.59,27.59s27.59-12.352464,27.59-27.59v-23c-.016534-15.230682-12.359318-27.573466-27.59-27.59Z",
  fill: "#6ace81"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg258",
  transform: "matrix(.997564-.069756 0.069756 0.997564-19.450596 11.430468)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M129.1,292.75c0,0,3.73,7.43,9.41,8c7.3.74,12.39-3.48,14.22-9.67c2.25-7.6-1.22-10.55-2.64-12c0,0-5.5-7.59-9.19-5.62s-11.84,3.61-11.8,4.2-.82,5.86-.82,5.86c-.54109,3.095328-.258291,6.278539.82,9.23Z",
  fill: "#ffdeab"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg260",
  d: "M-2.361413,0c0-2.082388,1.154804-1.01365,2.458976-1.01365s2.26385-1.068738,2.26385,1.01365-1.057241.649929-2.361413.649929-2.361413,1.494538-2.361413-.649929Z",
  transform: "matrix(1.0717-.358272 0.358272 1.0717 144.751205 293.191114)",
  opacity: 0,
  fill: "#333",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.1,292.75c0,0,3.73,7.43,9.41,8c7.3.74,12.39-3.48,14.22-9.67c2.25-7.6-1.22-10.55-2.64-12",
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg262",
  d: "M147.12,293.17c0,0-2.34-1.6-4,.56",
  transform: "translate(-.030575-.008767)",
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg263",
  opacity: 0
}, /*#__PURE__*/React.createElement("path", {
  d: "M147.12,293.17c0,0-2.34-1.6-4,.56",
  transform: "translate(3.31255-7.862931)",
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.12,293.17c0,0-2.34-1.6-4,.56",
  transform: "translate(-5.953832-4.793651)",
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M146.53,274c0,0,5.29,4.5-.48,8.52s-9.77-2.65-10.06-4.94c-1.2997,1.121811-2.935499,1.779648-4.65,1.87s2.65,4.88-.48,6.52l-2.25.28c0,0-4.52-3.53-4.22-9.25s3.75-6.83,6.55-5.67c0,0,2-6.63,11.45-4.21c7.24,1.85,12,5.64,12.21,9c.29,4.73-4.63,3.54-5.86,2.17",
  fill: "#6ace81",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg267"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 4.7,
  ry: 4.48,
  transform: "matrix(.138309-.990389 0.990389 0.138309 139.027989 286.247156)",
  fill: "#fff",
  stroke: "#333",
  strokeWidth: 0.94,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 4.7,
  ry: 3.84,
  transform: "matrix(.138309-.990389 0.990389 0.138309 151.097245 286.135083)",
  fill: "#fff",
  stroke: "#333",
  strokeWidth: 0.87,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.24,286.07c-1.122327-.77576-2.607673-.77576-3.73,0",
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.94,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("line", {
  x1: 134.76,
  y1: 284.85,
  x2: 128.55,
  y2: 284.45,
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.94,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("path", {
  d: "M131.15,291c0,0-2.94,3.37-6.18.29s.3-7.31,3.58-6.85c1.074201.220031,2.002579.88992,2.55,1.84",
  fill: "#ffdeab",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.17,286.81c0,0,2.35,1.21.91,3.31",
  fill: "none",
  stroke: "#333",
  strokeWidth: 0.97,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg274",
  d: "M138.446072,287.552855q-5.431332-11.116928-14.60724-3.465424-4.462868,3.721447-7.998832,12.159783",
  opacity: 0,
  fill: "none",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeDashoffset: 10,
  strokeDasharray: 5
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg275",
  d: "M148.807823,284.612251q1.235241-10.913352,6.046478-11.942787q5.682268-1.215805,6.443834,9.640147",
  opacity: 0,
  fill: "none",
  stroke: "#333",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeDashoffset: 10,
  strokeDasharray: 5
})))), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 1579.21,
  y1: 720,
  x2: 340.79,
  y2: 720,
  opacity: 0.6,
  fill: "#1e1e26",
  stroke: "#bab8c5",
  strokeMiterlimit: 10
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 1579.21,
  y1: 360,
  x2: 340.79,
  y2: 360,
  opacity: 0.6,
  fill: "#1e1e26",
  stroke: "#bab8c5",
  strokeMiterlimit: 10
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  r: 20.12,
  transform: "matrix(.84 0 0 0.84 312.359998 178.310001)",
  fill: "url(#eZ2eP1AIHkg278-fill)"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    "isolation": "isolate"
  },
  transform: "matrix(-.37 0 0 0.37 1855.4 747.671891)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg450)"
}, /*#__PURE__*/React.createElement("g", null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg283"
}, /*#__PURE__*/React.createElement("path", {
  d: "M551.89,600.58c-17.78-3.39-56.18-24.48-67.51-33.41-9.63-7.61-17.76-11.95-24.84-13.28-5.69-1.07-10.45-.15-14.54,2.81-7.88,5.72-12.05,28.26-13.16,43.56c22.16,5.18,76.84,23.1,100.34,30.91",
  fill: "#e89f97",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538.36,597.51l8.28.23l6.73-3.15l3.92,1.22c0,0,5.87-1.76,8.74-1.75s26.09,20.15,31.46,22.49c0,0-1.42,15.6-.94,18.28c0,0-11.4,16.79-12.23,18.43l-3.14-.67c0,0-1.67-6.11.18-10.21c1.131998-2.490411,2.551661-4.839735,4.23-7s-1.18-9.72-.56-12.91l-6.75-3.37l2,7.34c0,0-4.5,13.71-5.42,15.53l-8.43,11.61-4.43-3.83l3.21-10.9l2.11-10.08-6,10.26-11.23,10.17-3.55-2.84l5.07-12.11-9.44,10.25-3.67-1.78c0,0,0-8.49,1.46-11.77c0,0-16,13.15-24.06,11.22s-18.9-6.75-18.29-16.57c.89-13.96,38.1-26.76,40.75-28.09Z",
  fill: "url(#eZ2eP1AIHkg285-fill)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M572.59,602c.473924.851012.904475,1.725464,1.29,2.62.72,1.59,1.56,3.75,2.29,6c.67656,2.012953,1.25063,4.058912,1.72,6.13.39,1.7.53,2.88.53,2.88s-.58-1-1.29-2.63-1.55-3.75-2.28-5.94-1.35-4.44-1.73-6.14-.53-2.92-.53-2.92Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.52,603.09c.63,1.62,1.21,3.26,1.77,4.91s1.07,3.3,1.59,5s1,3.31,1.49,5s1,3.26,1.51,4.92v.09c.050203.128608.050203.271392,0,.4q-1.1,2.32-2.27,4.62t-2.46,4.53c.53-1.64,1.09-3.26,1.7-4.87s1.23-3.2,1.89-4.79v.5c-.29-.83-.59-1.66-.87-2.49s-.58-1.68-.81-2.51c-.46-1.68-.95-3.35-1.37-5s-.82-3.38-1.19-5.08-.71-3.51-.98-5.23Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M553.17,605.62l1.3,7.42c.1.62.23,1.23.36,1.84s.23,1.23.39,1.83l.43,1.8.53,1.74c.060893.157658.060893.332342,0,.49-1.16,2.69-2.34,5.37-3.56,8s-2.49,5.31-3.8,7.93c-.75,1-1.47,1.9-2.22,2.78s-1.47,1.79-2.24,2.66c.59-1,1.22-2,1.84-2.95s1.25-2,1.9-2.91l-.05.08q1.61-4.1,3.34-8.13c1.16-2.69,2.36-5.36,3.58-8v.49l-.5-1.88-.36-1.88c-.12-.62-.17-1.25-.26-1.88s-.16-1.25-.22-1.88c-.13-1.26-.25-2.51-.31-3.77s-.16-2.52-.15-3.78Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537,613.56c1.06,2.34,2,4.72,2.82,7.13s1.6,4.84,2.32,7.28c.039919.126935.039919.263065,0,.39q-.74,2.32-1.54,4.64c-.29.76-.56,1.54-.87,2.29s-.6,1.53-.94,2.28c.11-.82.27-1.62.42-2.43s.32-1.6.48-2.4c.36-1.6.75-3.18,1.16-4.76v.39c-.78-2.43-1.54-4.86-2.19-7.33s-1.27-4.95-1.66-7.48Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.22,624.29l1.61.78c.48.21,1,.46,1.62.69.606537.236829,1.227852.433912,1.86.59.3285.088893.662579.155709,1,.2.310612.059014.624524.099088.94.12.569121.04478,1.140879.04478,1.71,0c.422133-.024906.842695-.071635,1.26-.14h.51l-.4.31c-.358434.277289-.756119.499723-1.18.66-.280787.128949-.576325.222983-.88.28-.325617.093665-.661414.147393-1,.16-.749234.051863-1.501951-.015645-2.23-.2-.720872-.18743-1.413612-.469907-2.06-.84-.552608-.315272-1.066148-.694553-1.53-1.13-.491335-.419644-.907325-.920185-1.23-1.48Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M542.17,644.5c-1.15,1-4.22-.26-3.67-1.94s2.43-4.67,3.41-6.58s6.56,1.62,5.51,2.78-4.1,4.69-5.25,5.74Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546.75,645.72c1.25-2.31,1.65-4.13,3.27-6s6.75,3.43,6.75,3.43-6,5.94-6.73,6.48-4.54-1.63-3.29-3.91Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.47,651.37c0,0,1.86-2.79,3.23-5s4.57-.81,4.57-.81l-5.83,8Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M580.88,651.74c1.183046-2.532079,2.51884-4.98994,4-7.36l4.8.68c0,0-4.46,6.9-5.33,8.2s-4.11-.14-3.47-1.52Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.28,617.5c0,0-.25.29-.62.82-.508797.732112-.950583,1.508586-1.32,2.32-.248508.524533-.468822,1.061965-.66,1.61-.194467.611786-.344852,1.23672-.45,1.87c0,.33-.11.66-.13,1s0,.68,0,1c.023783.69437.097305,1.386142.22,2.07.152469.680012.352972,1.348355.6,2c.244149.645258.531465,1.273345.86,1.88.35.58.63,1.18,1,1.7s.72,1,1,1.44c.62.92,1.28,1.59,1.68,2.11s.64.81.64.81-.3-.21-.83-.61l-.93-.74c-.418655-.294319-.807208-.629279-1.16-1-.4-.41-.83-.86-1.27-1.35s-.8-1.1-1.21-1.7c-.394002-.634567-.728748-1.304058-1-2-.294877-.726952-.532272-1.475916-.71-2.24-.136039-.779242-.202965-1.568978-.2-2.36c0-.39.05-.77.07-1.16s.15-.74.22-1.1c.160643-.687321.388403-1.357203.68-2c.269633-.56739.583957-1.112441.94-1.63.513622-.769569,1.121697-1.47171,1.81-2.09.234123-.242043.4921-.459816.77-.65Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546.64,597.74c2.17-1.19,4.39-2.31,6.58-3.46.07383-.029493.15617-.029493.23,0l4,1.12h-.23c2.9-.66,5.8-1.32,8.7-1.93.165552-.038151.339514-.005533.48.09c2.68,1.82,5.32,3.68,8,5.51l3.94,2.8c1.33.91,2.6,1.91,3.9,2.86c2.6,1.91,5.14,3.91,7.71,5.86s5.09,4,7.59,6c-2.72-1.75-5.42-3.52-8.07-5.35s-5.33-3.62-7.95-5.48l-7.92-5.54c-2.63-1.86-5.28-3.7-7.88-5.59l.48.1c-2.91.56-5.84,1.06-8.77,1.57-.071814.021112-.148186.021112-.22,0l-3.89-1.32h.24c-2.34.86-4.56,1.85-6.92,2.76Z",
  fill: "#ffcdc7"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M388.31,589.82c-5.8-56.56-30.49-106.33-48.9-154.16-13.87-36-20.44-83.63-22.85-105-.708071-6.363931-6.086799-11.178518-12.49-11.18h-198.07c4.100756.244911,7.289276,3.662125,7.25,7.77-.28,19.31,0,70.83,10,110.41c12.53,49.69,31.07,102.07,30,158.92-.77,42.38-7.52,66.57-9.67,73.27l243.49-4.17c0,0,6.39-25.59,1.24-75.86Z",
  fill: "#5432fc",
  fillRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M133.18,596.62c-.92,50.52-10.34,75.2-10.34,75.2h20.09c0,0,9.42-24.68,10.33-75.2.5-27.18-3.48-53.34-9.14-78.67l-18.2,8.8c4.63,22.58,7.7,45.82,7.26,69.87Z",
  fill: "#5432fc",
  fillRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M142.44,670.74l.36-1.11c2.06-6.42,8.86-30.66,9.63-73c.83-45.24-10.72-87.42-21.88-128.21-2.88-10.51-5.59-20.43-8.13-30.48-10-39.45-10.34-90.51-10-110.64.04195-3.657377-2.81668-6.692739-6.47-6.87h-.78v-1.62h.83h198.07c6.826956-.00614,12.565417,5.124871,13.32,11.91c2.18,19.37,8.77,68.34,22.79,104.77c3.72,9.65,7.6,19.17,11.72,29.25c16,39.26,32.59,79.86,37.23,125.12c5.11,49.83-1.18,75.93-1.25,76.19l-.15.62h-.64ZM110.57,320.36c2.203364,1.618337,3.482615,4.206676,3.43,6.94-.29,20.06.11,70.94,10,110.2c2.53,10,5.24,19.95,8.12,30.45c11.19,40.91,22.77,83.2,21.94,128.68-.74,40.47-7,64.54-9.37,72.4l241.68-4.13c.9-4.2,5.71-29.7,1.07-75-4.62-45-21.14-85.51-37.12-124.66-4.12-10.09-8-19.62-11.73-29.29-14.09-36.6-20.71-85.74-22.89-105.17-.662732-5.943078-5.690088-10.43625-11.67-10.43Z",
  fill: "#2b00ff"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M478.53,534.22c3.08-16.14,6.93-36.22,4.93-60.52l-.07-.83.15-.83c5-26.77-7.5-47.29-4.52-59.65l-48.77-1.91c0,0,45.05,2.1,45.05,2.1-3,12.36,9.54,32.88,4.52,59.65l-.15.83.07.83c2,24.3-1.84,44.38-4.93,60.52-2.26,11.79-4.11,21.5-3.12,29.69l-55.22,39.33c.19,1.46.3,2.24.3,2.24l58.64-41.76c-1-8.19.86-17.91,3.12-29.69Z",
  fill: "#ffc7de",
  fillRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M430.25,410.48L479,412.39c-3,12.36,9.54,32.88,4.52,59.65l-.15.83.07.83c2,24.3-1.85,44.38-4.93,60.52-2.26,11.79-4.12,21.5-3.12,29.69l-58.64,41.76c0,0-16.84-115.67,13.5-195.19Z",
  fill: "#e89f97",
  fillRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M123.09,671c0,0,9.42-24.68,10.33-75.2c1-56.85-17.5-109.23-30-158.92-10.12-40.11-7-92.48-5.4-111.17.338143-3.965412,3.660208-7.009189,7.64-7h.15c2.049843-.002891,4.015095.81699,5.455124,2.275819s2.234353,3.434548,2.204876,5.484181c-.28,19.32,0,70.83,10,110.41c12.54,49.69,31.07,102.07,30,158.92-.92,50.52-10.34,75.2-10.34,75.2Z",
  fill: "url(#eZ2eP1AIHkg302-fill)",
  fillRule: "evenodd"
})), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg303"
}, /*#__PURE__*/React.createElement("path", {
  d: "M481,389.7c0,0-1.13,60,9.48,86.68c0,0-45.52,24-75.88,24.85c0,0-1.68-69.77,16.09-95.35s50.31-16.18,50.31-16.18Z",
  fill: "#171c85",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M414.59,501.23l5-.47c1.66-.16,3.3-.51,4.95-.76s3.28-.6,4.91-1s3.27-.69,4.88-1.16l4.83-1.31l4.79-1.48c1.6-.47,3.17-1.05,4.75-1.58s3.17-1.07,4.72-1.68c3.14-1.15,6.25-2.37,9.35-3.63s6.18-2.54,9.23-3.9c6.11-2.7,12.18-5.54,18.08-8.61l-.36,1-1.16-3.4-.58-1.69c-.18-.57-.41-1.13-.55-1.71l-1.72-6.93l1.31.47-4,2.95-2,1.47L479,469.2l-4.15,2.73c-1.37.92-2.84,1.69-4.26,2.54l-4.3,2.48-4.44,2.22c-1.48.73-2.95,1.49-4.44,2.2l-4.59,1.89-4.58,1.88-4.71,1.56-4.71,1.55c-1.55.56-3.19.85-4.78,1.28l-4.81,1.19-2.4.58c-.81.17-1.63.28-2.44.41l-9.77,1.57.14-.16Zm0,0l-.19-8.12c-.001379-.077863.053503-.145411.13-.16l9.69-1.88c.81-.17,1.62-.3,2.42-.49l2.37-.66l4.75-1.28c1.58-.47,3.19-.78,4.73-1.37l4.64-1.63l4.64-1.64l4.51-2l4.51-2c1.47-.71,2.92-1.48,4.39-2.21l4.38-2.22l4.23-2.5c1.4-.85,2.85-1.61,4.21-2.53l4.08-2.73l2-1.37l2-1.47l3.93-2.94c.368014-.276051.889613-.204721,1.17.16.067077.092845.114697.198289.14.31l1.7,6.83c.13.58.36,1.12.53,1.67l.55,1.67l1.11,3.32c.149154.378921-.01013.809419-.37,1-6,3.07-12.09,5.87-18.25,8.54-1.54.66-3.08,1.33-4.64,1.95s-3.09,1.3-4.67,1.88q-4.69,1.82-9.45,3.46c-1.58.58-3.18,1.08-4.78,1.59s-3.19,1.05-4.81,1.49l-4.84,1.39-4.89,1.18c-1.63.43-3.29.69-4.94,1s-3.29.65-5,.83-3.33.5-5,.58Z",
  fill: "#121666"
}), /*#__PURE__*/React.createElement("path", {
  d: "M423.08,667.35c3.8-10.36,21.2-58.2,20.15-62.84-1.17-5.2-6.49-14-6.49-14l32.66-203c-58.26-3.4-87.46-32.47-87.46-32.47l-60.87-6c-42.07,42.75-115.38,63.4-117.73,70.41-4,11.92,8.5,47.21,14,78.67s3.85,77.6,6.57,102c2,18.26,13.27,51.62,18.8,67.25Z",
  fill: "#2128ba"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg307"
}, /*#__PURE__*/React.createElement("path", {
  d: "M213.28,482l59.31-31.52c2.69,12.42,8.33,37.5,15.45,63.79l.22.81.42.72c12.37,21,17.64,40.77,21.87,56.64c3.1,11.6,5.65,21.15,10.1,28.09L286,663.59c0,0-65.47-96.83-72.72-181.59Z",
  fill: "#e89f97",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.55,572.4c-4.23-15.87-9.5-35.63-21.87-56.64l-.42-.72-.22-.81c-7.12-26.29-12.76-51.37-15.45-63.79L213.28,482c0,.05,56-29.73,56-29.73c2.69,12.42,8.33,37.5,15.45,63.79l.22.8.42.72c12.37,21,17.64,40.78,21.88,56.65c3.09,11.6,5.64,21.15,10.1,28.09l-32.63,59.43c.8,1.23,1.24,1.88,1.24,1.88l34.65-63.1c-4.41-6.98-6.96-16.53-10.06-28.13Z",
  fill: "#ffc7de",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  d: "M359.3,415.82c-21.82,0-46.75-10.48-58-24.38-5-6.12-6.91-12.5-5.65-18.44c2.44-11.5,30.42-22.37,57.58-22.37c14,0,26.57,2.95,36.33,8.54c10.85,6.21,16.21,16.48,14.34,27.48-2.34,13.81-15.24,24.85-32.86,28.13-3.871319.690376-7.797685,1.025104-11.73,1Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M310.17,374.76c0,.06,0,.13-.05.2l73.46,8.13c0-34.88.42-36.77,11.77-71.87.583254-1.880889,1.040928-3.798444,1.37-5.74c2.306778-14.032467-3.49188-28.167016-14.988987-36.536478s-26.729588-9.544796-39.374532-3.038126-20.543289,19.584362-20.416481,33.804604c0,38-.13,38.9-11.81,75Z",
  fill: "#e89f97",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M468.12,395.38c-2.44,16.29-4.79,32.59-7.34,48.86L457,468.65l-3.85,24.4-7.79,48.78-8,48.75-.05-.39l6.43,15c.049716.135586.049716.284414,0,.42l-10,28.51-10.17,28.47l9.49-28.7l9.61-28.66v.42l-6.62-14.88c-.056529-.121721-.073995-.257956-.05-.39l7.73-48.79l7.91-48.76l4-24.38l4.08-24.36c2.74-16.26,5.62-32.48,8.4-48.71Z",
  fill: "#575dd9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.89,373.69c-4.3,20.28,38.53,43.94,71.53,37.81c31.65-5.87,40.71-36.14,17.47-49.44-32.2-18.44-86.23-1.42-89,11.63Z",
  fill: "#e89f97",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M236.57,570.15l59-41.4c-2-4.27-4.28-8.6-6.87-13l-.42-.72-.22-.81c-3.06-11.31-5.85-22.39-8.25-32.34L216.56,504.7c4.37,22.56,11.98,45.35,20.01,65.45Z",
  opacity: 0.29,
  fill: "#a15889",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.2,517.84c0,0-12.73-67.5-38.31-94.6-21.41-22.69-58.65-11.09-57.56,2.79.95,12,13.21,117.78,13.21,117.78s13.06-3.2,28.81-7.94c26.39-7.95,44.4-16.8,53.85-18.03Z",
  fill: "#2b34f0",
  fillRule: "evenodd"
}))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M141.39,668.53h-14.83l.31-1.07c2.48-8.43,8.34-32.28,9-71.6.83-45.71-10.77-88.13-22-129.14-2.87-10.5-5.58-20.41-8.11-30.43-9.92-39.33-7-90.27-5.33-110.35.214785-2.679684,2.461789-4.739075,5.15-4.72c1.432963-.028836,2.815862.527212,3.83,1.54.977122.975896,1.51196,2.309377,1.48,3.69-.29,20.19.11,71.42,10.11,111.07c2.56,10.12,5.39,20.48,8.14,30.51c11.13,40.68,22.64,82.74,21.82,127.74-.76,41.55-7.41,65.75-9.44,72.17Zm-12.61-1.67h11.39c2.19-7.16,8.44-31,9.18-71.12.81-44.76-10.67-86.7-21.77-127.26-2.75-10-5.59-20.42-8.14-30.56-10-39.84-10.45-91.24-10.16-111.49.015617-.933755-.344722-1.834603-1-2.5-.708949-.682434-1.666946-1.043943-2.65-1-1.819875-.016418-3.343219,1.37598-3.49,3.19-1.7,20-4.57,70.72,5.29,109.81c2.52,10,5.23,19.9,8.1,30.38c11.26,41.14,22.89,83.67,22.06,129.62-.69,37.94-6.17,61.6-8.81,70.93Z",
  fill: "#fff"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M395.31,311.22c.615263-1.874699,1.086631-3.793599,1.41-5.74c2.306778-14.032467-3.49188-28.167016-14.988987-36.536478s-26.729588-9.544796-39.374532-3.038126-20.543289,19.584362-20.416481,33.804604c0,31.91-.09,37.67-7.05,60.13l71.22-17.36c1.7-7.85,4.53-16.69,9.24-31.26Z",
  opacity: 0.43,
  fill: "#8c4d77",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#eZ2eP1AIHkg321)"
}, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M294.26,496.63h-77.18l.27,1.49c5.51,31.45,3.85,77.6,6.57,102c2,18.26,13.27,51.62,18.8,67.25h51.54Z",
  fill: "url(#eZ2eP1AIHkg320-fill)"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "eZ2eP1AIHkg321",
  maskType: "luminance",
  x: "-150%",
  y: "-150%",
  height: "400%",
  width: "400%"
}, /*#__PURE__*/React.createElement("g", {
  mask: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(255.670006 582)"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "mixBlendMode": "multiply"
  },
  d: "M294.26,496.63h-77.18l.27,1.49c5.51,31.45,3.85,77.6,6.57,102c2,18.26,13.27,51.62,18.8,67.25h51.54Z",
  fill: "url(#eZ2eP1AIHkg324-fill)"
}))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M386.14,340.73l-.55,6.15c-.38,3.66-.88,8.55-1.38,13.43-.16,1.22-.26,2.44-.34,3.64s-.21,2.38-.31,3.53-.13,2.25-.2,3.3-.12,2-.17,3s0,1.75,0,2.5s0,1.4,0,1.94c0,1.08,0,1.7,0,1.7s-.12-.6-.31-1.66c-.08-.54-.19-1.19-.31-1.94-.172666-.830295-.279663-1.672901-.32-2.52c0-.93-.07-1.94-.11-3s-.11-2.2,0-3.36c.11-2.31.17-4.8.45-7.25.14-1.23.28-2.46.42-3.67s.35-2.38.52-3.53c.35-2.29.75-4.41,1.16-6.22s.79-3.31,1-4.36.45-1.68.45-1.68Z",
  fill: "#ffc7de"
})), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg327",
  transform: "matrix(.994522-.104528 0.104528 0.994522-64.086742 32.782126)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M448.24,611.75c-26.08,3.85-89.3-3.7-109.31-9-17-4.56-30.33-6-40.7-4.47-8.36,1.25-14.42,4.38-18.55,9.58-8,10-2.43,37.78,3.69,55.88c33-3.69,117-6.88,153.1-8.13",
  fill: "#e89f97",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.57,603.9c0,0-1.3,1.42-3,3.67-.43.56-.88,1.17-1.34,1.83s-.9,1.38-1.4,2.09-.9,1.52-1.36,2.31-.89,1.6-1.23,2.45c-.408365.820522-.765711,1.665461-1.07,2.53L296.7,620c-.12.43-.25.85-.37,1.26-.251656.792974-.45207,1.601308-.6,2.42-.180354.727377-.313961,1.465553-.4,2.21-.07.69-.19,1.33-.25,1.91s-.05,1.07-.07,1.49l-.11,1.32c0,0-.11-.47-.29-1.29-.08-.42-.18-.93-.3-1.51s-.09-1.25-.13-2c0-.37,0-.75,0-1.15s.07-.8.1-1.22c.043169-.88279.167019-1.759779.37-2.62.168202-.93498.412344-1.854693.73-2.75.300935-.929019.661689-1.837585,1.08-2.72.412734-.885866.869984-1.750303,1.37-2.59.49-.83,1.06-1.59,1.59-2.33.996864-1.333682,2.11496-2.572292,3.34-3.7c1.149454-1.095634,2.429017-2.04607,3.81-2.83Z",
  fill: "url(#eZ2eP1AIHkg329-fill)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M450.24,607.36l8.08-1.82l5.75-4.71l4.1.22c0,0,5.26-3.15,8-3.84s30.24,13.1,36,14c0,0,2.46,15.46,3.58,17.94c0,0-6.92,19.09-7.32,20.88l-3.2.12c0,0-3.12-5.51-2.34-9.93.479221-2.695338,1.278197-5.323901,2.38-7.83s-3.54-9.13-3.72-12.37l-7.37-1.62l3.75,6.63c0,0-1,14.39-1.44,16.38l-5.31,13.33-5.18-2.57.43-11.35-.43-10.29-3.27,11.41-8.39,12.63-4.14-1.88l1.94-13L465.5,652l-4-.82c0,0-2.13-8.22-1.48-11.77c0,0-12.25,16.68-20.56,16.8s-20-1.89-21.8-11.56c-2.57-13.79,30.34-35.35,32.58-37.29Z",
  fill: "url(#eZ2eP1AIHkg330-fill)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M484.53,603.32c0,0,.82.85,1.9,2.22s2.43,3.26,3.68,5.2s2.39,4,3.18,5.53c.451005.862239.85819,1.746698,1.22,2.65s-.82-.85-1.89-2.22-2.43-3.26-3.69-5.2-2.39-4-3.18-5.53-1.22-2.65-1.22-2.65Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476,606.57c1,1.42,2,2.87,2.92,4.33s1.85,2.93,2.76,4.41s1.79,3,2.68,4.45s1.8,2.91,2.66,4.4l.05.08c.066136.122199.090707.262603.07.4-.32,1.68-.68,3.36-1.06,5s-.81,3.34-1.28,5c.11-1.72.26-3.43.45-5.14s.41-3.41.65-5.1l.12.48c-.49-.73-1-1.46-1.45-2.2s-1-1.48-1.41-2.23c-.86-1.51-1.74-3-2.57-4.54s-1.62-3.08-2.4-4.63-1.5-3.11-2.19-4.71Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M466.59,611.57l3.08,6.87c.26.58.53,1.14.81,1.7s.53,1.13.83,1.67l.85,1.65.95,1.55c.092783.141618.128511.313112.1.48-.46,2.9-.95,5.78-1.47,8.66s-1.11,5.76-1.73,8.62c-.49,1.15-1,2.2-1.47,3.24s-1,2.1-1.52,3.13c.33-1.11.7-2.21,1.06-3.31s.73-2.2,1.12-3.29v.09c.37-2.91.77-5.81,1.24-8.7s1-5.78,1.49-8.66l.1.48-.94-1.7-.81-1.73c-.27-.58-.48-1.18-.72-1.77s-.47-1.17-.68-1.77c-.43-1.18-.86-2.37-1.22-3.58s-.77-2.4-1.07-3.63Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M452.83,623.26c1.61,2,3.09,4.08,4.49,6.21s2.74,4.3,4,6.49c.073581.108768.108772.238975.1.37-.09,1.63-.2,3.26-.36,4.88-.08.82-.15,1.63-.27,2.44s-.2,1.62-.35,2.44c-.1-.82-.14-1.64-.2-2.46s-.08-1.63-.12-2.45c-.05-1.63-.05-3.26,0-4.89l.1.37c-1.36-2.16-2.69-4.33-3.93-6.56s-2.42-4.5-3.46-6.84Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M444.09,636.55l1.76.35c.51.09,1.1.2,1.73.27.646378.08572,1.297989.125819,1.95.12.333007.020854.666993.020854,1,0c.315656-.019022.629689-.059111.94-.12.564673-.085788,1.120319-.223026,1.66-.41.402586-.120544.796776-.26753,1.18-.44l.48-.18c0,0-.1.15-.31.4-.28338.359714-.620702.673423-1,.93-.236121.198574-.498617.363475-.78.49-.29809.173748-.617407.308197-.95.4-.714661.243302-1.465075.36499-2.22.36-.740686-.00346-1.477453-.107751-2.19-.31-.617086-.167123-1.211477-.408909-1.77-.72-.552374-.296479-1.052351-.681596-1.48-1.14Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M465.5,652c-.86,1.3-4.16.79-4-1s1.21-5.12,1.69-7.22s6.76,0,6,1.34-2.83,5.54-3.69,6.88Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M470.23,652c.65-2.54.59-4.41,1.7-6.62s7.39,1.67,7.39,1.67-4.39,7.24-4.93,7.93-4.8-.41-4.16-2.98Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M488.8,653.13c0,0,1.12-3.16,1.9-5.64s4.22-1.92,4.22-1.92l-3.67,9.22Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504.8,649.45c.498603-2.738743,1.166552-5.443934,2-8.1l4.82-.53c0,0-2.62,7.79-3.15,9.26s-3.95.92-3.67-.63Z",
  fill: "#fea098",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M418.25,636.1c-.146683.309558-.276866.626669-.39.95-.318933.832566-.559965,1.692917-.72,2.57-.109942.572115-.19005,1.149562-.24,1.73-.049663.639037-.049663,1.280963,0,1.92c0,.33.05.67.11,1s.17.66.24,1c.184732.68662.428991,1.355821.73,2c.309634.629928.66736,1.235053,1.07,1.81.394917.563859.825813,1.101643,1.29,1.61.49.47.91,1,1.37,1.4s.94.79,1.36,1.15c.83.74,1.63,1.22,2.14,1.63s.83.63.83.63-.35-.13-1-.4l-1.09-.48c-.483283-.192456-.945676-.433705-1.38-.72l-1.56-1c-.53-.39-1.05-.87-1.59-1.35-.548317-.514911-1.050253-1.07708-1.5-1.68-.465345-.63298-.879967-1.301726-1.24-2-.322145-.720117-.583067-1.466087-.78-2.23l-.21-1.14c-.05-.38,0-.76-.06-1.13-.016306-.707316.040664-1.414419.17-2.11.112379-.617032.279712-1.222777.5-1.81.312734-.875081.732593-1.708082,1.25-2.48.2027-.313369.437283-.604921.7-.87Z",
  fill: "#ba7ba5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458.32,605.54c1.81-1.69,3.69-3.31,5.53-5c.056403-.053807.132093-.082641.21-.08l4.14.11h-.22c2.64-1.36,5.29-2.71,8-4c.15351-.064448.32649-.064448.48,0c3.05,1.1,6.06,2.26,9.08,3.39l4.51,1.73c1.51.57,3,1.21,4.48,1.82c3,1.21,5.95,2.52,8.92,3.78s5.9,2.59,8.83,3.94c-3.07-1-6.12-2.08-9.14-3.2s-6.14-2.16-9.14-3.33l-9-3.41c-3-1.16-6-2.29-9-3.49h.5c-2.69,1.26-5.41,2.47-8.12,3.68-.071729.021692-.148271.021692-.22,0l-4.1-.33.24-.07c-2.01,1.5-3.97,3.01-5.98,4.46Z",
  fill: "#ffcdc7"
}))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M249.69,416c0,0,.41.18,1.14.6c1.044127.623752,2.046273,1.315233,3,2.07.69811.514315,1.365892,1.068574,2,1.66.7.64,1.52,1.28,2.26,2.09l2.46,2.5l2.51,3c.91,1,1.69,2.18,2.58,3.34s1.8,2.36,2.61,3.69l2.6,4c.89,1.36,1.63,2.86,2.47,4.32c1.71,2.93,3.19,6.09,4.73,9.29l1.16,2.4l1.05,2.48l2.09,5c.71,1.66,1.31,3.36,1.89,5l1.78,5.05c1.24,3.33,2.13,6.7,3.13,9.92s1.89,6.36,2.57,9.38s1.41,5.84,2,8.46s1,5.06,1.47,7.21.76,4,1.05,5.57c.57,3.09.89,4.85.89,4.85s-.44-1.74-1.2-4.79c-.37-1.52-.83-3.38-1.34-5.5s-1-4.54-1.78-7.12-1.49-5.4-2.31-8.37-1.78-6.06-2.78-9.27-1.94-6.54-3.21-9.83l-1.82-5c-.59-1.68-1.21-3.35-1.93-5l-2-5-1-2.47-1.13-2.39c-1.49-3.18-2.92-6.34-4.59-9.24-.81-1.47-1.54-2.94-2.37-4.33l-2.44-4c-.76-1.34-1.66-2.53-2.47-3.73s-1.57-2.36-2.44-3.38l-2.38-3-2.3-2.59c-.7-.84-1.47-1.51-2.13-2.18-.602653-.619403-1.240369-1.203698-1.91-1.75-1.202326-1.107582-2.512145-2.092458-3.91-2.94Z",
  fill: "#575dd9"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#eZ2eP1AIHkg346)"
}, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M214.54,543.81c0,0,13.06-3.2,28.81-7.94c26.39-8,44.4-16.8,53.85-18c0,0-1.22-6.45-3.66-16.16-14.09,6-41.18,16.12-80.93,25.44c1.17,10.06,1.93,16.66,1.93,16.66Z",
  fill: "url(#eZ2eP1AIHkg345-fill)",
  fillRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "eZ2eP1AIHkg346",
  maskType: "luminance",
  x: "-150%",
  y: "-150%",
  height: "400%",
  width: "400%"
}, /*#__PURE__*/React.createElement("g", {
  mask: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(254.904984 522.759995)"
}, /*#__PURE__*/React.createElement("path", {
  style: {
    "mixBlendMode": "multiply"
  },
  d: "M214.54,543.81c0,0,13.06-3.2,28.81-7.94c26.39-8,44.4-16.8,53.85-18c0,0-1.22-6.45-3.66-16.16-14.09,6-41.18,16.12-80.93,25.44c1.17,10.06,1.93,16.66,1.93,16.66Z",
  fill: "url(#eZ2eP1AIHkg349-fill)",
  fillRule: "evenodd"
}))))), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M739.62,646.24h-252.72c-4.179552-.002102-8.096115-2.039913-10.496537-5.461409s-2.983795-7.797775-1.563463-11.728591l77.69-214.72c3.369729-9.320789,12.218785-15.530723,22.13-15.53h252.72c4.183848-.003731,8.106296,2.034347,10.508249,5.460018s2.98118,7.807892,1.551751,11.739982L761.75,630.71c-3.369729,9.320789-12.218785,15.530723-22.13,15.53Z",
  fill: "#14243a",
  fillRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M827.38,398.8h-252.72c-9.911215-.000723-18.760271,6.209211-22.13,15.53l-8.26,22.82h287.52L839.44,416c1.429429-3.93209.850202-8.314311-1.551751-11.739982s-6.324401-5.463749-10.508249-5.460018Z",
  fill: "#1c3252",
  fillRule: "evenodd"
})), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "539.57,450.14 827.09,450.14 829.09,444.62 541.57,444.62 539.57,450.14",
  fill: "#1c3252",
  fillRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M478.17,632.38l77.69-214.72c3.370974-9.324238,12.225119-15.534937,22.14-15.53h252.71c2.583341-.006098,5.107784.771459,7.24,2.23-2.386191-3.488255-6.343685-5.569965-10.57-5.56h-252.72c-9.911215-.000723-18.760271,6.209211-22.13,15.53L474.84,629.05c-2.021608,5.513744-.035057,11.695957,4.82,15-2.370572-3.414052-2.92671-7.769842-1.49-11.67Z",
  fill: "#2b34f0",
  fillRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M739.62,647.07h-252.72c-4.451894-.002746-8.623586-2.173192-11.180986-5.817238s-3.180119-8.30517-1.669014-12.492762L551.75,414c3.529049-9.607431,12.674919-15.99477,22.91-16h252.72c4.452926-.005368,8.628556,2.161614,11.187486,5.80585s3.179449,8.307566,1.662514,12.49415L762.54,631c-3.51197,9.634709-12.665185,16.052342-22.92,16.07Zm-165-247.44c-9.560812.01944-18.090263,6.012029-21.35,15l-77.65,214.7c-1.325194,3.675609-.777932,7.766256,1.466841,10.964262s5.905956,5.102901,9.813159,5.105738h252.72c9.560812-.01944,18.090263-6.012029,21.35-15l77.69-214.71c1.329305-3.676799.784066-7.770666-1.461215-10.971386s-5.909067-5.106951-9.818785-5.108614Z",
  fill: "#2b34f0"
})), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
  points: "604.91,502.38 572.82,643.21 687.16,643.21 604.91,502.38",
  fill: "#05040d",
  fillRule: "evenodd"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 149.86,
  height: 155.66,
  rx: 0,
  ry: 0,
  transform: "translate(604.91 502.38)",
  fill: "#2b34f0"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#eZ2eP1AIHkg361)"
}, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "754.77,547.11 604.91,626.51 604.91,658.03 754.77,658.03 754.77,547.11",
  fill: "url(#eZ2eP1AIHkg360-fill)"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "eZ2eP1AIHkg361",
  maskType: "luminance",
  x: "-150%",
  y: "-150%",
  height: "400%",
  width: "400%"
}, /*#__PURE__*/React.createElement("g", {
  mask: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(679.839996 602.570007)"
}, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "mixBlendMode": "multiply"
  },
  points: "754.77,547.11 604.91,626.51 604.91,658.03 754.77,658.03 754.77,547.11",
  fill: "url(#eZ2eP1AIHkg364-fill)"
})))))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
  points: "181.66,657.91 129.82,657.91 120.74,556.23 190.74,556.23 181.66,657.91",
  fill: "url(#eZ2eP1AIHkg365-fill)"
})), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
  points: "196.66,563.61 114.82,563.61 116.05,552.95 195.43,552.95 196.66,563.61",
  fill: "#ffac60",
  fillRule: "evenodd"
})), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
  points: "181.71,552.95 167.76,552.95 169,563.61 182.94,563.61 181.71,552.95",
  opacity: 0.1,
  fill: "#fff",
  fillRule: "evenodd"
})), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
  points: "186.74,638.63 124.74,638.63 120.28,593.15 191.2,593.15 186.74,638.63",
  fill: "#2932e6"
})), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
  points: "187.74,552.95 123.74,552.95 125.38,543.61 186.09,543.61 187.74,552.95",
  fill: "url(#eZ2eP1AIHkg369-fill)",
  fillRule: "evenodd"
})), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
  points: "175.08,543.61 163.53,543.61 165.17,552.95 176.72,552.95 175.08,543.61",
  opacity: 0.1,
  fill: "#fff",
  fillRule: "evenodd"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#eZ2eP1AIHkg374)"
}, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "189.38,571.44 190.08,563.61 121.4,563.61 122.1,571.44 189.38,571.44",
  fill: "url(#eZ2eP1AIHkg373-fill)"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "eZ2eP1AIHkg374",
  maskType: "luminance",
  x: "-150%",
  y: "-150%",
  height: "400%",
  width: "400%"
}, /*#__PURE__*/React.createElement("g", {
  mask: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(155.740002 567.524994)"
}, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "mixBlendMode": "multiply"
  },
  points: "189.38,571.44 190.08,563.61 121.4,563.61 122.1,571.44 189.38,571.44",
  fill: "url(#eZ2eP1AIHkg377-fill)"
}))))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
  points: "182.49,657.99 180.83,657.84 182.38,640.46 185.98,640.46 190.28,593.98 186.84,593.98 189.31,562.78 195.72,562.78 194.69,553.78 187.04,553.78 185.4,544.45 125.38,544.45 125.38,542.78 186.79,542.78 188.44,552.11 196.17,552.11 197.59,564.44 190.85,564.44 188.64,592.32 192.11,592.32 187.5,642.13 183.9,642.13 182.49,657.99",
  fill: "#fff"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 70.92,
  height: 1.67,
  rx: 0,
  ry: 0,
  transform: "translate(120.28 592.31)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#eZ2eP1AIHkg383)"
}, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "183.19,640.71 183.38,638.63 128.1,638.63 128.28,640.71 183.19,640.71",
  fill: "url(#eZ2eP1AIHkg382-fill)"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "eZ2eP1AIHkg383",
  maskType: "luminance",
  x: "-150%",
  y: "-150%",
  height: "400%",
  width: "400%"
}, /*#__PURE__*/React.createElement("g", {
  mask: "none"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(155.740005 639.670013)"
}, /*#__PURE__*/React.createElement("polygon", {
  style: {
    "mixBlendMode": "multiply"
  },
  points: "183.19,640.71 183.38,638.63 128.1,638.63 128.28,640.71 183.19,640.71",
  fill: "url(#eZ2eP1AIHkg386-fill)"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg387",
  transform: "matrix(.956305 0.292372-.292372 0.956305 100.544168-91.300863)"
}, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M432.67,204.5c11.27-13.1,48.74,23.13,46.26,35.47-1.67,8.34-20.06,2-20.06,2s2.3,10.25-7.75,12.59-20.83-27.36-20.83-27.36-8.89-9.6,2.38-22.7Z",
  fill: "#fff",
  fillRule: "evenodd"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M474.74,237.93c1.38-6.88-9.67-21.19-21.66-30.24-6-2.64-11.4-3-14.64.8-11.27,13.11-2.38,22.7-2.38,22.7s4.79,13.18,11,21.29c9.92-2.38,7.65-12.56,7.65-12.56s18.35,6.35,20.03-1.99Z",
  fill: "#03020e",
  fillRule: "evenodd"
})), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
  points: "466.35,271.01 412.86,264.52 414.73,273.97 465.02,275.51 466.35,271.01",
  fill: "#291333",
  fillRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M447.1,272.12c-7.5,44.54-28,96.65-61.67,83.41-47.36-18.64-62.57-80.43-57.73-121.26c8.37-70.66,140.5-87.27,119.4,37.85Z",
  fill: "#e89f97",
  fillRule: "evenodd"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M416.64,289.15c0,0,.13,5.85,4.48,7.92c0,0-3.93,2.9-9.62.06",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.45,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M385.43,355.53c23.24,9.14,40.22-12.9,51-42.08-15.9-28.37-47,1.85-71.13-12.13-15.39-8.94-13.63-31.81-13.63-31.81-7.718811.407782-15.387625,1.485163-22.92,3.22c5.37,34.03,22.8,69.46,56.68,82.8Z",
  opacity: 0.43,
  fill: "#b36f9c",
  fillRule: "evenodd"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M447.1,272.12c9.43-56-11.76-83.55-38.82-90.67c25.5,8.41,44.69,36,35.63,89.72-7.18,42.61-26.28,92.11-57.39,84.72c33,11.7,53.16-39.72,60.58-83.77Z",
  fill: "#fff"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M312.27,161.57c4.52-1,21.72,9.87,10.28,27.77c0,0-14.8-26.8-10.28-27.77Z",
  fill: "#14243a",
  fillRule: "evenodd"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M321.91,181.34c0,0-15.8-8.49-16.94-5-1.51,4.59,12.89,12.39,16.94,5Z",
  fill: "#14243a",
  fillRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M408,232.29c.41.77-11.58,11.37-23.56,9.3-5.73-1-11.87-5.71-10.12-5.91c7.41-.87,32.77-5.01,33.68-3.39Z",
  fill: "#291333",
  fillRule: "evenodd"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M430.75,233.15c-.73.46,4.34,15.64,15.74,19.85c5.46,2,13.14,1,11.73-.05-6.03-4.48-25.91-20.77-27.47-19.8Z",
  fill: "#291333",
  fillRule: "evenodd"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M369.94,254.1c0,0-52-7-64.22-7.82-7.68-.49-1.09,9.5,1.87,9.45c8.86-.17,61,2.87,61,2.87Z",
  fill: "#291333",
  fillRule: "evenodd"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M440.1,290.19c-.836489-.152814-1.664311-.349756-2.48-.59-11.637882-3.456132-18.553247-15.396936-15.759039-27.21123s14.325949-19.392158,26.279039-17.26877c.836725.15169,1.664607.348646,2.48.59c11.637882,3.456132,18.553247,15.396936,15.759039,27.21123s-14.325949,19.392158-26.279039,17.26877Zm7.75-43.43c-11.098317-2.006331-21.82712,5.019486-24.424511,15.994529s3.844197,22.064463,14.664511,25.245471c.758674.228008,1.529979.411652,2.31.55c11.092683,1.991183,21.80689-5.036283,24.399868-16.003912s-3.839915-22.049029-14.649868-25.236088c-.756854-.22218-1.524511-.40575-2.3-.55Z",
  fill: "#291333"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M386.83,283.68c-.837481-.148056-1.665567-.34506-2.48-.59-11.862425-3.531472-18.759792-15.862402-15.56053-27.818703s15.333032-19.194888,27.373907-16.330324s19.615051,14.791733,17.087415,26.907816-14.238928,20.019953-26.420792,17.831211Zm7.75-43.42c-11.092683-1.991183-21.80689,5.036283-24.399868,16.003912s3.839915,22.049029,14.649868,25.236088c.755475.224718,1.523455.405026,2.3.54c11.067838,1.941045,21.730078-5.082467,24.316005-16.017624s-3.801069-21.990444-14.566005-25.212376c-.755292-.228004-1.523269-.41165-2.3-.55Z",
  fill: "#291333"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M413.36,264.63c-.455635-.05799-.77799-.474365-.72-.93s.474365-.77799.93-.72l9.92.75c.458396.035899.800899.436604.765.895s-.436604.800899-.895.765l-9.91-.75Z",
  fill: "#291333"
})), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg403"
}, /*#__PURE__*/React.createElement("path", {
  d: "M440.45,274.05c-.657946,2.217906-2.988901,3.48288-5.207062,2.825793s-3.484037-2.987552-2.827809-5.205967s2.986202-3.485195,5.204871-2.829826c1.066543.315044,1.96409,1.041168,2.494913,2.018406s.65137,2.125417.335087,3.191594Z",
  fill: "#291333",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M399.12,270.59c-.520963,1.76992-2.057131,3.051505-3.891764,3.246799s-3.606166-.734194-4.488042-2.354785-.700297-3.612901.460016-5.047367s3.070689-2.028384,4.83979-1.504647c2.404694.723295,3.778564,3.248006,3.08,5.66Z",
  fill: "#291333",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M393,271.83c.227981.065044.463057.101985.7.11-1.344286-.434886-2.159258-1.797457-1.906514-3.187548s1.495182-2.378587,2.906514-2.312452h-.09c-.984222-.342108-2.076822-.115697-2.844049.589352s-1.084956,1.774669-.82705,2.784231s1.049718,1.795736,2.061099,2.046417Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M435.23,275.51c.228058.063318.463336.096929.7.1-1.32582-.44786-2.122636-1.800265-1.871859-3.177033s1.473275-2.361355,2.871859-2.312967h-.09c-1.499453-.441828-3.073172.415547-3.515,1.915s.415547,3.073172,1.915,3.515Z",
  fill: "#fff",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.07,263.49c.208989-.69745.548314-1.348954,1-1.92.442444-.610403.975211-1.149913,1.58-1.6.353726-.254587.728401-.478723,1.12-.67.414987-.189997.846878-.340657,1.29-.45.449117-.106365.908507-.163369,1.37-.17.440022-.002829.879116.040746,1.31.13.396968.083869.785298.204386,1.16.36.334235.126754.652953.291146.95.49.452766.272751.863689.609573,1.22,1c.27.27.41.43.41.43l-.58-.14c-.466496-.150961-.940457-.277796-1.42-.38-.29,0-.59-.16-.92-.18s-.66-.09-1-.1-.7,0-1.05,0c-.338849.023765-.674133.084116-1,.18-.695777.159427-1.368018.408156-2,.74-.58075.302981-1.144888.63679-1.69,1-1.09.72-1.75,1.28-1.75,1.28Z",
  fill: "#291333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M433,266.07c.4258-.587504.958411-1.089583,1.57-1.48.610775-.435032,1.285509-.7724,2-1c.417696-.122066.846456-.202458,1.28-.24.455568-.044796.914432-.044796,1.37,0c.455924.058182.904846.162037,1.34.31.414894.149334.813596.340309,1.19.57.353277.21851.687763.46603,1,.74.270733.2306.509504.496275.71.79.337301.40056.613614.848726.82,1.33.16.34.24.54.24.54l-.5-.33c-.384457-.301574-.78505-.581989-1.2-.84-.26-.14-.5-.35-.8-.49s-.6-.31-.92-.44-.65-.26-1-.33c-.343743-.108449-.69999-.172304-1.06-.19-.71017-.095-1.42983-.095-2.14,0-.653349.09421-1.301001.224408-1.94.39-1.17.37-1.96.67-1.96.67Z",
  fill: "#291333"
}))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg413)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 19.93,
  height: 62.31,
  rx: 0,
  ry: 0,
  transform: "matrix(.584816 0.811166-.811166 0.584816 400.56807 217.152579)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg413"
}, /*#__PURE__*/React.createElement("path", {
  d: "M394.58,240.26c-11.098317-2.006331-21.82712,5.019486-24.424511,15.994529s3.844197,22.064463,14.664511,25.245471c.759144.223632,1.530389.403923,2.31.54c11.092683,1.991183,21.80689-5.036283,24.399868-16.003912s-3.839915-22.049029-14.649868-25.236088c-.757007-.218911-1.524667-.399144-2.3-.54Z",
  fill: "none"
})))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eZ2eP1AIHkg418)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  width: 19.93,
  height: 62.31,
  rx: 0,
  ry: 0,
  transform: "matrix(.584816 0.811166-.811166 0.584816 450.747322 221.883067)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg418"
}, /*#__PURE__*/React.createElement("path", {
  d: "M447.7,246.61c-11.065878-1.919032-21.710672,5.116697-24.282136,16.049396s3.821047,21.975747,14.582136,25.190604c.755767.223619,1.523683.403912,2.3.54c11.042624,1.872966,21.639515-5.158874,24.204538-16.061543s-3.785151-21.92157-14.504538-25.168457c-.755392-.227632-1.523348-.411274-2.3-.55Z",
  fill: "none"
})))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M463.27,178.8C421,154.49,353.14,139.34,323,175.08c-10,11.85-14.49,21.89-12.87,30-7.67,62.42-.61,83.27,2.34,95.26c2.11,8.54,11.24,8.16,11.24,8.16-1.41-16.84,2.27-54.19,8.61-48.78c0,0,6.35,25.53,15.11,22.22s1-36,1-36l1.37-1.11c15.26,5.46,66.65-18.36,66.65-18.36s-5.87,10.69-.36,12.39c7,2.16,23.77-23.38,25.33-22.39s-6.84,14.27-1.16,16.43c7.28,2.77,31.3-32.8,31.3-32.8c5.12-7.34,6.78-12.62-8.29-21.3Z",
  fill: "#03020e"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#eZ2eP1AIHkg425)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  style: {
    "mixBlendMode": "screen"
  },
  opacity: 0.88
}, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  d: "M463.27,178.8C421,154.49,353.14,139.34,323,175.08c-10,11.85-14.49,21.89-12.87,30-7.67,62.42-.61,83.27,2.34,95.26c2.11,8.54,11.24,8.16,11.24,8.16-1.41-16.84,2.27-54.19,8.61-48.78c0,0,6.35,25.53,15.11,22.22s1-36,1-36l1.37-1.11c15.26,5.46,66.65-18.36,66.65-18.36s-5.87,10.69-.36,12.39c7,2.16,23.77-23.38,25.33-22.39s-6.84,14.27-1.16,16.43c7.28,2.77,31.3-32.8,31.3-32.8c5.12-7.34,6.78-12.62-8.29-21.3Z",
  fill: "#0037ff"
})))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "eZ2eP1AIHkg425",
  maskType: "luminance",
  x: "-150%",
  y: "-150%",
  height: "400%",
  width: "400%"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
  width: 173,
  height: 160,
  xlinkHref: "data:image/png;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "translate(304.4 151.4)"
}))))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  r: 16.15,
  transform: "matrix(.81825-.574862 0.574862 0.81825 365.394908 295.597405)",
  opacity: 0.3,
  fill: "#ff7769"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M345.64,282.72c-3.35-11.54-13.54-37.72-26.34-32.81-7.92,3-8.29,17.25-1.43,27.94c13.87,21.61,31.13,16.42,27.77,4.87Z",
  fill: "#e897b9",
  fillRule: "evenodd"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M335.73,275.13c0,0-5-15-10.46-12.86s-1.39,16.18,6.29,18.57s4.17-5.71,4.17-5.71Z",
  fill: "#9c5484",
  fillRule: "evenodd"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M320.69,257.9c.404025.02326.805412.080123,1.2.17c1.031384.230522,2.03658.565588,3,1c.660489.285707,1.298903.619955,1.91,1c.700436.409027,1.369002.870338,2,1.38c1.369415,1.098677,2.598627,2.361474,3.66,3.76.49.75,1,1.47,1.45,2.23s.82,1.54,1.15,2.3.58,1.53.84,2.24.38,1.43.54,2.07c.244408,1.032798.411537,2.082369.5,3.14.08.76.11,1.19.11,1.19s-.17-.41-.43-1.12-.56-1.75-1.09-2.92l-.79-1.91c-.33-.65-.68-1.34-1-2.05s-.82-1.38-1.2-2.11-.94-1.37-1.4-2.07-1-1.32-1.58-1.92-1.1-1.22-1.7-1.72c-1.053198-.97741-2.187247-1.863908-3.39-2.65-.861894-.565878-1.760553-1.073671-2.69-1.52-.68-.33-1.09-.49-1.09-.49Z",
  fill: "#4a225e"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M334.48,270.15l-1.67-.93c-.538532-.28449-1.092754-.53823-1.66-.76-.303372-.119489-.613991-.219688-.93-.3-.305899-.088793-.621658-.13918-.94-.15-.613278-.063725-1.233107.000983-1.82.19-.29.07-.55.24-.83.33-.254416.125884-.50148.266109-.74.42-.48.26-.82.58-1.11.76-.148126.107766-.301659.207896-.46.3s.06-.18.2-.5c.173634-.456694.420166-.882215.73-1.26.193803-.274961.422367-.523693.68-.74.302568-.263401.638855-.485351,1-.66.375529-.201997.780468-.343726,1.2-.42.437025-.091642.885141-.118596,1.33-.08.431107.048485.856455.138913,1.27.27.384858.136119.753709.313838,1.1.53.602547.352878,1.14585.79832,1.61,1.32.438484.497672.790063,1.065608,1.04,1.68Z",
  fill: "#4a225e"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M416.49,226.51c0,0-47.11,18.59-66.49,18.41.17.06.35.1.52.15.416961.127885.841011.231393,1.27.31c17.21,3.14,64.7-18.87,64.7-18.87Z",
  fill: "#fff"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg434",
  d: "M1712.923934,881.686512q-9.260372-9.655703,3.519286-21.142155",
  transform: "matrix(.525184 0.850989-.850989 0.525184 240.264407-1591.818985)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round"
})), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg435",
  transform: "matrix(.987063 0.160331-.160331 0.987063 388.164577 315.13478)",
  opacity: 0
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M14,16.22c-7.27,0-13.18-5.15-13.18-11.49c0-2.63,1.06-3.91,3.26-3.91c1.264657.071175,2.518269.275641,3.74.61c2.017855.541412,4.091731.846789,6.18.91c2.084913-.063982,4.155389-.369352,6.17-.91c1.22192-.33349,2.47544-.537941,3.74-.61c2.2,0,3.27,1.28,3.27,3.91c0,6.34-5.92,11.49-13.18,11.49Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.91,1.63c1.54,0,2.45.71,2.45,3.1c0,5.9-5.54,10.68-12.36,10.68s-12.37-4.78-12.37-10.68c0-2.39.91-3.1,2.45-3.1c2.26,0,5.86,1.53,9.92,1.53s7.66-1.53,9.91-1.53m0-1.63v0c-1.322336.074121-2.63304.28866-3.91.64-1.960222.521092-3.972919.819642-6,.89-2.027027-.070949-4.039658-.36949-6-.89C6.719955,0.287213,5.405781,0.072654,4.08,0C2.56,0,0,0.61,0,4.73C0,11.52,6.28,17,14,17s14-5.48,14-12.27C28,0.61,25.44,0,23.91,0Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14,16.22c-6.64,0-12.27-4.35-13-10.13-.041216-.305411.09445-.607753.35-.78.134765-.093943.29575-.142938.46-.14.136511-.001371.270991.033112.39.1C5,6.81,9.17,7.7,13.69,7.7c4.92,0,9.49-1.06,12.22-2.85.266095-.166523.603905-.166523.87,0c.269187.158508.421487.459203.39.77-.51,5.94-6.28,10.6-13.17,10.6Z",
  fill: "#d96283"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.36,5.54c-.48,5.52-5.81,9.87-12.33,9.87C7.7,15.41,2.48,11.29,1.76,6C5.477444,7.78336,9.568899,8.647607,13.69,8.52c5.27,0,9.91-1.18,12.67-3m0-1.64c-.316857-.000111-.626613.09386-.89.27-2.61,1.7-7,2.72-11.78,2.72C9.3,6.89,5.24,6,2.55,4.55c-.24351-.128988-.514448-.197579-.79-.2-.469336.00507-.914301.209783-1.223514.562896s-.453406.821205-.396486,1.287104C1,12.38,7,17,14,17c7.28,0,13.41-5,14-11.36.051035-.621813-.255174-1.218726-.79-1.54-.252316-.156372-.543158-.23947-.84-.24Z",
  fill: "#231f20"
})))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M417.15,239c.186547.00944.373453.00944.56,0l.33-.07.55-.16.36-.13.6-.27.35-.17c.23-.12.47-.26.7-.41l.28-.16c.34-.22.68-.45,1-.7l.21-.16.85-.66.37-.32.72-.61.4-.37c.24-.21.48-.42.71-.65l.41-.38.76-.75.35-.35l1-1l.12-.13l1.14-1.21c.08-.08.15-.17.22-.25l.9-1l.32-.36.81-.92.29-.34.85-1c.067958-.087914.141439-.171416.22-.25l1-1.2c3.62-4.28,6.56-8,7.61-8.45.018898-.079781-.01281-.163015-.08-.21-1.33-.85-18.77,17.15-26.73,21.16.137633.231491.305811.443395.5.63.08513.088443.175279.171914.27.25l.26.17c.239716.144215.494585.261589.76.35.244114.07069.496016.110995.75.12Z",
  fill: "#fff"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg442",
  rx: 2.50839,
  ry: 3.627508,
  transform: "matrix(1.863575 0.493629-.585997 2.212289 403.678936 327.316784)",
  opacity: 0,
  strokeWidth: 0
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M463.27,178.8l-.59-.1h-.24l-.53-.08h-.28l-.66-.11h-.28l-.84-.13h-.23c-1.61-.24-3.6-.52-5.93-.84c1.95.29,3.39.53,4.22.69c17.07,3.28,13.41,13.95,8.33,21.33c0,0-18,26.65-27.56,32c.073542.152018.157058.299005.25.44.113334.181727.247584.349539.4.5.062168.058725.12906.112239.2.16.233313.186799.492734.338409.77.45c7.28,2.77,31.3-32.8,31.3-32.8c5.08-7.55,8.74-18.22-8.33-21.51Z",
  fill: "#fff"
})), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg444",
  transform: "matrix(-.867061-.800378-.800378 0.867061 411.2199 317.992937)",
  opacity: 0
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M23.07,1.1c0,4-4.92,7.3-11,7.3s-11-3.27-11-7.3",
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 2.21,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.83,14.85c-1.090094.003953-2.119055-.503125-2.78-1.37L16.7,9.11c-.225645-.315839-.168898-.752352.13-1l4.69-3.59c.131014-.120488.302015-.188175.48-.19h.09c.19578.019216.374049.121084.49.28L25.9,9c1.169785,1.530111.878881,3.718608-.65,4.89l-.3.24c-.608061.466978-1.353315.720083-2.12.72Z",
  fill: "#d96282"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,5.07l3.35,4.37c.916525,1.212512.689356,2.936325-.51,3.87l-.31.23c-.477115.371677-1.065205.572403-1.67.57-.874763.005596-1.699619-.406832-2.22-1.11L17.28,8.66L22,5.07m0-1.48c-.326079.000653-.642686.109706-.9.31L16.39,7.49c-.312587.234394-.518185.584297-.570807.971444s.052123.779232.290807,1.088556l3.35,4.38c.802532,1.049159,2.049098,1.663194,3.37,1.66.930876.001742,1.835568-.308036,2.57-.88l.3-.23c1.850622-1.422297,2.203727-4.072824.79-5.93L23.14,4.17c-.243837-.314277-.604629-.51632-1-.56h-.19Z",
  fill: "#231f20"
}), /*#__PURE__*/React.createElement("line", {
  x1: 19.62,
  y1: 6.86,
  x2: 22.14,
  y2: 10.14,
  fill: "none",
  stroke: "#231f20",
  strokeWidth: 1.48,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})))))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "eZ2eP1AIHkg450"
}, /*#__PURE__*/React.createElement("path", {
  d: "M73.1,653.35h389.47c156.37,0,283.13-126.76,283.13-283.13v-286.72h-672.6Z",
  fill: "none"
})))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M745.7,83.5v286.72c0,156.37-126.76,283.13-283.13,283.13h-385.83",
  fill: "none",
  stroke: "#2575fc",
  strokeWidth: 10.7,
  strokeLinecap: "round",
  strokeMiterlimit: 10
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  rx: 87.24,
  ry: 67.49,
  transform: "translate(345.84 188.53)",
  fill: "#14243a"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M345.84,124.56c46.16,0,83.72,28.7,83.72,64s-37.56,64-83.72,64-83.72-28.7-83.72-64s37.56-64,83.72-64m0-7c-50.13,0-90.77,31.79-90.77,71s40.64,71,90.77,71s90.76-31.79,90.76-71-40.63-71-90.76-71Z",
  fill: "#2575fc"
})), _image || (_image = /*#__PURE__*/React.createElement("image", {
  id: "eZ2eP1AIHkg455",
  width: 300,
  height: 150,
  xlinkHref: "data:image/png;base64,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",
  preserveAspectRatio: "xMidYMid meet",
  transform: "matrix(0 0 0 0 354.057586 184.314797)"
})), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg456",
  transform: "matrix(.48 0 0 0.48 180.874378 99.871329)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M310.73,212.09c-1.119911,2.013566-1.535216,4.343496-1.18,6.62c1.11,6.23,8.23,8.38,8.53,8.47c2.06.59,2.4.07,7.77-.1c9-.29,10.53,1.06,12.69-.6c3.28-2.51,3-8.17,2.88-10.15c0-.71-1.65-6.43-1.65-6.43s-15.29-4.37-29.04,2.19Z",
  fill: "#c24434"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.92,208.48c.83,0,1.64,0,2.41.05-4.284352,3.282051-8.02662,7.216663-11.09,11.66-1.322762,1.916055-2.512233,3.920781-3.56,6-.42-.22-.87-.48-1.33-.78c1.061051-2.107838,2.267289-4.139398,3.61-6.08c2.79997-4.061695,6.152196-7.713468,9.96-10.85Z",
  fill: "#aa2f27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.18,217.71c-1.227769,1.789067-2.343249,3.652653-3.34,5.58-.36837-.426497-.702728-.881225-1-1.36.933187-1.750358,1.964842-3.446412,3.09-5.08c1.928197-2.791893,4.118099-5.393657,6.54-7.77.89-.15,1.77-.27,2.63-.36-2.975472,2.68357-5.632885,5.700002-7.92,8.99Z",
  fill: "#aa2f27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.85,216.71c2.044839-2.517509,3.922208-5.166538,5.62-7.93l1.69.21c-4.189375,6.949511-9.470279,13.179222-15.64,18.45-.488671-.028765-.972126-.116055-1.44-.26l-.46-.15c3.740706-3.095621,7.167262-6.552323,10.23-10.32Z",
  fill: "#aa2f27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M333.61,217.18c1.942581-2.384875,3.742391-4.882571,5.39-7.48l.81.2.27,1c-1.597376,2.525069-3.343805,4.952706-5.23,7.27-2.605381,3.198514-5.464664,6.181532-8.55,8.92h-.41c-.8,0-1.48.06-2.08.09c3.574077-3.017511,6.855301-6.365698,9.8-10Z",
  fill: "#aa2f27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M337.22,220.66c1.42-1.69,2.76-3.46,4-5.29.084737.328908.148202.662933.19,1c0,.35,0,.83.05,1.38-1,1.35-2,2.66-3.06,3.93-1.627708,1.946243-3.360277,3.802329-5.19,5.56-.63,0-1.33-.08-2.14-.11c2.187502-2.021662,4.2418-4.18285,6.15-6.47Z",
  fill: "#aa2f27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.19,211.88c.824074,2.353337.845174,4.9134.06,7.28-.833562,1.569484-1.779354,3.076735-2.83,4.51-3.15,4.73-3.35,4.73-3.77,5.91-.72,2-.53,2.95-1.66,4.13-.72068,1.050971-1.980693,1.594891-3.239809,1.398555s-2.293706-1.09806-2.660191-2.318555c-.75-1.59-.36-3.13.85-7c1.83-6,2-5.78,2.07-6.68.27-2.2-.28-5.5-4.29-9.95Z",
  fill: "#ab2426"
}), /*#__PURE__*/React.createElement("path", {
  d: "M337,232.1c2,0,4.46-5.26,5-7.89.44-2.29,1.44-8.05-.12-13.64l7.34,1.31c.824074,2.353337.845174,4.9134.06,7.28-.833562,1.569484-1.779354,3.076735-2.83,4.51-3.15,4.73-3.35,4.73-3.77,5.91-.72,2-.53,2.95-1.66,4.13-.72068,1.050971-1.980693,1.594891-3.239809,1.398555s-2.293706-1.09806-2.660191-2.318555c-.380582-.835675-.485641-1.770704-.3-2.67.56,1.07,1.32,1.99,2.18,1.98Z",
  fill: "#9f2121"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.8,204.64c.654341,2.676703,2.428449,4.942608,4.87,6.22.601896,1.787805,1.631802,3.401324,3,4.7.89.83,3.93,3.66,7.76,2.9c1.784525-.376476,3.378463-1.371801,4.5-2.81l.12-.17.09-.14.12-.2c.026996-.037748.05043-.07792.07-.12l.09-.15.09-.18c.027149-.041168.050575-.084673.07-.13l.07-.15c0-.07.06-.13.08-.19l.05-.12c.160982-.404585.284825-.822976.37-1.25.004817-.039855.004817-.080145,0-.12c0-.16.05-.31.07-.45v.25c.009343.725102.255125,1.427335.7,2c1.11,1.34,3.27,1.2,5.11,1c6.56-.64,8.83-1.75,12.36-2.08c2.41-.22,1.92.24,10.52,1.42l.46.06h.11l.54.07.54.07.51.07l1,.14h.24l1.42.19h.34.34v0h.29.33.24.05l.58.07.73.08.51.05h.1l.77.07h.55.58c1.003995.05556,2.011036-.00822,3-.19c1.32-.3,8.32-2,11.82-8.61.05-.11.11-.22.17-.33s.1-.22.16-.33c.19-.4.35-.8.5-1.2c0-.09.07-.18.1-.27.207513-.585335.377852-1.183192.51-1.79l.06-.25c0-.07,0-.13,0-.19s0-.25.07-.37s0-.24,0-.36l.06-.37c0-.16,0-.32.05-.47v-.2c.048261-.511842.068291-1.025954.06-1.54.005006-.06991.005006-.14009,0-.21.001343-.51801-.028712-1.035626-.09-1.55h.12c.56,0,1.2.07,1.92.07h.71.49.26.79.31l.47-.05.44-.05h.27.07.27l1.07-.18c3.36-.65,8.27-1.58,11.7-5.67.043647-.059088.090378-.115833.14-.17c2.045699-2.34719,3.13436-5.377594,3.05-8.49c0-.06,0-.13,0-.19s0-.15,0-.22v0c0-.14,0-.27-.05-.4v-.23-.19c.005649-.073225.005649-.146775,0-.22v-.18c-.05-.25-.11-.49-.17-.72v-.12c-.156436-.528398-.346833-1.046142-.57-1.55-.017224-.049479-.040751-.096533-.07-.14v0c0-.06-.06-.11-.08-.16l-.09-.18c-.019425-.045327-.042851-.088832-.07-.13l-.24-.45-.08-.14-.17-.28-.08-.13-.09-.13v0c-.046711-.060955-.090107-.12438-.13-.19l-.06-.09-.15-.2-.17-.24-.08-.1-.25-.31-.22-.26-.06-.07-.11-.13v0l-.05-.06c-.286028-.313859-.589863-.611016-.91-.89c0-.17.06-.43.08-.75.004963-.046535.004963-.093465,0-.14s0-.06,0-.09s0-.3,0-.46v-.16c0-.14,0-.28,0-.43.004963-.059897.004963-.120103,0-.18-.012146-.298202-.0422-.595404-.09-.89c0-.18-.06-.37-.1-.56v-.14l-.06-.3c0-.15-.08-.3-.13-.45.004527-.049898.004527-.100102,0-.15c0-.13-.08-.25-.13-.38l-.15-.39-.06-.16-.14-.32-.24-.47-.18-.32-.19-.32c-1.0979-1.7159-2.672083-3.074632-4.53-3.91-.623017-2.049628-1.770958-3.900812-3.33-5.37-2.811174-2.449088-6.51059-3.625517-10.22-3.25-1.871953-1.606166-4.094977-2.750218-6.49-3.34-2.312583-.56045-4.721057-.598029-7.05-.11-2.39568-1.549507-5.151829-2.452146-8-2.62-.732474-.050193-1.467526-.050193-2.2,0-.725679.053669-1.447163.153875-2.16.3l-.25.06h-.08l-.22.05h-.06c-.51.13-1,.27-1.42.42-.687137.228522-1.35576.509343-2,.84-4.008959-.898299-8.168074.674145-10.58,4-.435205-.201528-.886851-.365459-1.35-.49-.762369-.208793-1.549563-.313079-2.34-.31v0c-.438819.003499-.876742.040271-1.31.11-2.362024.431338-4.453764,1.788629-5.81,3.77-3.119507-.276649-6.226278.653951-8.68,2.6-2.439917,2.014674-3.985365,4.911491-4.3,8.06-1.620298.212158-3.125021.953973-4.28,2.11-2.82,2.9-1.82,7-1.75,7.28-1.894772.686899-3.324061,2.270854-3.813349,4.225998s.025461,4.025607,1.373349,5.524002c-1.892065.925762-3.210722,2.719541-3.529817,4.801637s.401839,4.188457,1.929817,5.638363c-.46545.824118-.80265,1.714328-1,2.64-.004527.049898-.004527.100102,0,.15v.14v0v.13c0,.16-.06.33-.08.51.004859.053223.004859.106777,0,.16c0,.05,0,.1,0,.15-.004899.063239-.004899.126761,0,.19-.00475.073256-.00475.146744,0,.22-.004958.043192-.004958.086808,0,.13c0,.15,0,.31,0,.47v.26c-.043938.495467-.050624.993533-.02,1.49Z",
  fill: "#f58d7d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.8,204.64c.654341,2.676703,2.428449,4.942608,4.87,6.22.601896,1.787805,1.631802,3.401324,3,4.7.89.83,3.93,3.66,7.76,2.9c1.784525-.376476,3.378463-1.371801,4.5-2.81l.12-.17.09-.14.12-.2c.026996-.037748.05043-.07792.07-.12l.09-.15.09-.18c.027149-.041168.050575-.084673.07-.13l.07-.15c0-.07.06-.13.08-.19l.05-.12c.160982-.404585.284825-.822976.37-1.25.004817-.039855.004817-.080145,0-.12c0-.16.05-.31.07-.45v.25c.009343.725102.255125,1.427335.7,2c1.11,1.34,3.27,1.2,5.11,1c6.56-.64,8.83-1.75,12.36-2.08c2.41-.22,1.92.24,10.52,1.42l.46.06h.11l.54.07.54.07.51.07l1,.14h.24l1.42.19h.34.34v0h.29.33c6.35-1.74,10-7.29,10.57-13.65.153239-3.706376-.899395-7.362524-3-10.42l-.22-.2-.16-.15-.17-.16-.22-.21-.06-.06c-.44-.43-.86-.85-1.16-1.19.377874.782749.669585,1.604235.87,2.45.84,3.25,1.33,8.94-3.58,12.32-5.25,3.6-13.89-5.07-23.33-.61-3.18,1.51-5.55,4.08-8.46,3.18-2.19-.67-3.45-2.94-4.15-4.71-.63.62-5.85,5.57-13.06,4.54-4.066872-.621862-7.709559-2.861574-10.1-6.21-.004527.049898-.004527.100102,0,.15v.14v0v.13c0,.16-.06.33-.08.51.004859.053223.004859.106777,0,.16c0,.05,0,.1,0,.15-.004899.063239-.004899.126761,0,.19-.00475.073256-.00475.146744,0,.22-.004958.043192-.004958.086808,0,.13c0,.15,0,.31,0,.47v.26c-.024301.581224.002469,1.163458.08,1.74Zm21.46,7.63v0c-.005373-.046512-.005373-.093488,0-.14v-.13c.004931-.076587.004931-.153413,0-.23.005485-.053192.005485-.106808,0-.16-.000489.230887-.017196.461455-.05.69Z",
  fill: "#e56059"
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.12,215.73h.24.05l.58.07.73.08.51.05h.1l.77.07h.55.58c1.003995.05556,2.011036-.00822,3-.19c1.32-.3,8.32-2,11.82-8.61.05-.11.11-.22.17-.33s.1-.22.16-.33c.19-.4.35-.8.5-1.2c0-.09.07-.18.1-.27.207513-.585335.377852-1.183192.51-1.79l.06-.25c0-.07,0-.13,0-.19s0-.25.07-.37s0-.24,0-.36l.06-.37c0-.16,0-.32.05-.47v-.2c.048261-.511842.068291-1.025954.06-1.54.005006-.06991.005006-.14009,0-.21.001343-.51801-.028712-1.035626-.09-1.55-1.21-.25-2.48-.57-3.8-1-2.955889-.858939-5.714622-2.289267-8.12-4.21-.45-.35-.86-.7-1.24-1c2.100605,3.057476,3.153239,6.713624,3,10.42-.43,6.46-4.07,12.02-10.42,13.75Z",
  fill: "#d04139"
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.7,149.57c2.662934.181639,5.160838,1.355654,7,3.29.470854.547052.864516,1.156051,1.17,1.81c5.049651-1.155616,10.351313.019267,14.44,3.2h.05c.41.32.74.61,1,.85c5.403038.159488,9.836817,4.327154,10.33,9.71.44.23,7.43,4,7.6,10.5.038563,1.706279-.408833,3.38835-1.29,4.85-1.699556,2.589446-4.056641,4.680798-6.83,6.06-.998076.545724-2.030205,1.026716-3.09,1.44l-1,.34c-.902711.282014-1.825297.495947-2.76.64h-.37c-3.900668.448876-7.850686-.141039-11.45-1.71-.3-.13-.57-.25-.81-.37s-.66-.32-.84-.42c.29.32.62.67,1,1l.06.06.22.21.17.16.16.15.22.2.41.36.18.16.48.39.11.09v0h.05v0l.19.15.2.15.2.15.41.3.21.15.22.15c.22.15.44.3.67.44l.22.14.25.15.18.11.14.08.16.1.5.27.21.11h.07l.24.12.26.13c.27.14.54.27.82.39l.23.1.25.1.2.09h.06v0l.29.11v0l.36.13v0c.110019.048835.223701.088959.34.12l.27.1.17.05v0h.12v0l.23.07.31.09c1.32.38,2.59.7,3.8,1h.12c.56,0,1.2.07,1.92.07h.71.49.26.79.31l.47-.05.44-.05h.27.07.27l1.07-.18c3.36-.65,8.27-1.58,11.7-5.67.043647-.059088.090378-.115833.14-.17c2.045699-2.34719,3.13436-5.377594,3.05-8.49c0-.06,0-.13,0-.19s0-.15,0-.22v0c0-.14,0-.27-.05-.4v-.23-.19c.005649-.073225.005649-.146775,0-.22v-.18c-.05-.25-.11-.49-.17-.72v-.12c-.156436-.528398-.346833-1.046142-.57-1.55-.017224-.049479-.040751-.096533-.07-.14v0c0-.06-.06-.11-.08-.16l-.09-.18c-.019425-.045327-.042851-.088832-.07-.13l-.24-.45-.08-.14-.17-.28-.08-.13-.09-.13v0c-.046711-.060955-.090107-.12438-.13-.19l-.06-.09-.15-.2-.17-.24-.08-.1-.25-.31-.22-.26-.06-.07-.11-.13v0l-.05-.06c-.286028-.313859-.589863-.611016-.91-.89c0-.17.06-.43.08-.75.004963-.046535.004963-.093465,0-.14s0-.06,0-.09s0-.3,0-.46v-.16c0-.14,0-.28,0-.43.004963-.059897.004963-.120103,0-.18-.012146-.298202-.0422-.595404-.09-.89c0-.18-.06-.37-.1-.56v-.14l-.06-.3c0-.15-.08-.3-.13-.45.004527-.049898.004527-.100102,0-.15c0-.13-.08-.25-.13-.38s-.1-.26-.15-.39l-.06-.16-.14-.32-.24-.47-.18-.32-.19-.32c-1.0979-1.7159-2.672083-3.074632-4.53-3.91-.623017-2.049628-1.770958-3.900812-3.33-5.37-2.811174-2.449088-6.51059-3.625517-10.22-3.25-1.871953-1.606166-4.094977-2.750218-6.49-3.34-2.312583-.56045-4.721057-.598029-7.05-.11-2.39568-1.549507-5.151829-2.452146-8-2.62-.732474-.050193-1.467526-.050193-2.2,0-.725679.053669-1.447163.153875-2.16.3l-.25.06h-.08l-.22.05Z",
  fill: "#e8625b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.24,181.57c.179158-.010653.350494-.077089.49-.19c1.009149-.87648,1.607129-2.13405,1.65-3.47-.019474-1.513105-.739787-2.931567-1.95-3.84-.373208-.271678-.895711-.191292-1.17.18-.128417.177319-.180591.398629-.144903.614636s.156275.408774.334903.535364c.775317.593137,1.241882,1.504225,1.27,2.48-.034856.866709-.425566,1.680689-1.08,2.25-.341349.297407-.381391.813501-.09,1.16.174704.194474.42918.29774.69.28Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.74,188.85c2.002323-.124534,3.9353-.780366,5.6-1.9c1.891112-1.20807,3.211682-3.131194,3.66-5.33.64-3.56-1.67-6.46-2.4-7.27-.310018-.313667-.811207-.330114-1.141122-.037447s-.373343.792242-.098878,1.137447c.6.67,2.51,3.05,2,5.88-.55,3.12-4.11,6.17-9.09,5.89-.455031-.028594-.847939.315201-.88.77-.016464.219896.057436.437.204638.601187s.35498.261261.575362.268813c.52297.031703,1.047476.028362,1.57-.01Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.35,166.54c.419854-.029989.750784-.369515.77-.79.008087-.219199-.071985-.4325-.222319-.59223s-.358395-.252569-.577681-.25777c-2.6374-.104837-5.230515-.712386-7.64-1.79-2.683029-1.20243-5.084557-2.953331-7.05-5.14-.312262-.288191-.79175-.293998-1.1109-.013455s-.374872.756818-.1291,1.103455c2.120555,2.364434,4.71289,4.25844,7.61,5.56c2.602158,1.160966,5.402623,1.812711,8.25,1.92Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.32,185.88c.195074-.009251.38153-.083129.53-.21.338795-.306926.365621-.830027.06-1.17-1.130184-1.236052-2.454193-2.279722-3.92-3.09-2.029091-1.11148-4.280251-1.757109-6.59-1.89-.311092-.047723-.622415.084615-.803923.341735s-.201973.594784-.052845.871942.442189.446127.756768.436323c2.060299.117224,4.06876.69107,5.88,1.68c1.30931.723071,2.491575,1.655372,3.5,2.76.161959.181548.396944.280682.64.27Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M315.67,196.74c.333996-.022381.621856-.243205.73-.56c1.379044-4.218551,5.090443-7.246272,9.5-7.75.218854-.025081.418761-.136133.555685-.308696s.199634-.392478.174315-.611304c-.062238-.453193-.475665-.773266-.93-.72-5.03967.59189-9.279305,4.051464-10.87,8.87-.119531.418513.108741.857498.52,1c.099039.05107.20858.078455.32.08Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330,203c.300002-.024619.563162-.209733.687721-.483763s.090993-.59402-.087721-.836237c-2.62-3.43-3.26-6.54-1.63-7.91c1.08-.9,4.1.24,6.72,3.32.298299.347811.822016.388097,1.17.09.179831-.134539.29661-.33695.32307-.559975s-.039713-.447141-.18307-.620025c-3.15-3.69-7-5.2-9.06-3.51-2.4,2-1.88,5.91,1.38,10.16.157332.21907.410288.349269.68.35Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.76,185c1.461713-.150827,2.739011-1.052895,3.37-2.38.986183-1.963716,1.660915-4.068881,2-6.24.053196-.219344.01363-.450917-.109376-.640156s-.318572-.31941-.540624-.359844c-.219121-.050208-.449237-.009388-.637719.113125s-.319208.31624-.362281.536875c-1,5-2.12,7.18-3.86,7.3-.136262.014867-.273738.014867-.41,0-1.69-.17-2.26-2.17-2.1-7.41.008104-.21825-.07227-.430524-.22289-.588676s-.358725-.248778-.57711-.251324c-.220169-.008102-.434525.071664-.595839.221724s-.256347.358097-.264161.578276c-.142076,2.008434-.010878,4.026858.39,6c.5,1.9,1.58,2.95,3.2,3.11.239009.028221.4803.031572.72.01Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M367.44,162.06v0c.454974-.037192.794517-.434815.76-.89-.086021-1.296068-.599496-2.527002-1.46-3.5-1.62029-1.694392-4.034356-2.372629-6.3-1.77-.215104.049913-.401451.183484-.517809.371159s-.153134.413979-.102191.628841c.1132.440544.556489.71095,1,.61c1.673047-.465094,3.466612.017789,4.68,1.26.618345.705139.98734,1.594241,1.05,2.53.037192.454974.434815.794517.89.76Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336,156.09c.182928-.010279.3564-.084624.49-.21c1.197409-1.057744,2.641769-1.797119,4.2-2.15c1.356399-.305,2.763601-.305,4.12,0c.287599.064308.587659-.029701.78715-.246615s.268108-.523779.18-.805-.319551-.494077-.60715-.558385c-3.480335-.769566-7.118514.179039-9.78,2.55-.263162.234186-.347343.610286-.209122.934311s.467952.523561.819122.495689Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.59,162.89c.148043-.010495.290137-.06248.41-.15.18116-.121618.305591-.311181.34512-.525767s-.009188-.436045-.13512-.614233c-1.036245-1.378601-2.455144-2.421909-4.08-3-1.813505-.583988-3.783354-.436878-5.49.41-.19375.103369-.337226.280976-.397555.492127s-.03234.437748.077555.627873c.107326.192373.286723.334189.498675.394211s.439069.033324.631325-.074211c1.302852-.623907,2.795433-.724128,4.17-.28c1.285904.481243,2.406864,1.321095,3.23,2.42.178029.221457.458016.334965.74.3Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M358,176.27c1.73799-.135814,3.340276-.991333,4.42-2.36.137989-.170507.201912-.389191.177483-.607175s-.135174-.417092-.307483-.552825c-.361755-.277442-.87797-.220085-1.17.13-.832004,1.062673-2.091179,1.703242-3.44,1.75-.887648.061268-1.758626-.263072-2.39-.89-.83-1-.92-3,.41-4.66.279493-.35959.217019-.877231-.14-1.16-.362819-.280577-.883623-.218258-1.17.14-1.7,2.14-1.86,5.06-.35,6.77.955996.997639,2.300426,1.527374,3.68,1.45Z",
  fill: "#fac6bf"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.35,182.43c2.28.15,10.13,1.15,15.65,7.77l.08.09c.34.4.86,1,1.45,1.85c1.58,2.22,3.58,5.79,3.33,9.89-.23,3.73-2.3,7.47-5.83,10.53-1.391734,1.193504-2.910929,2.229776-4.53,3.09v0h.29.33.24.05l.58.07.73.08.51.05v0c5.43-3.51,9-8.48,9.29-13.83.096874-3.336938-.820116-6.624852-2.63-9.43-.434247-.710467-.904873-1.398048-1.41-2.06-.45-.6-.85-1.07-1.13-1.41l-.07-.09c-2.686815-3.193769-6.192025-5.596255-10.14-6.95-2.153068-.768471-4.400027-1.242755-6.68-1.41-.43022.008967-.782241.345248-.810865.774609s.275642.809394.700865.875391Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330,154.05c1.748843,2.482733,4.040104,4.534609,6.7,6c3.31,1.76,6.67,2.26,9.93,2.74c4.19.62,7.81,1.15,10.4,4.28.609147.730026,1.113968,1.541105,1.5,2.41.144821.31798.471359.513107.82.49.096227-.009671.190543-.03325.28-.07.415249-.186654.602636-.672969.42-1.09-.452838-1.003512-1.038041-1.941854-1.74-2.79-3-3.61-7.09-4.22-11.43-4.86-3.255445-.29863-6.433445-1.16505-9.39-2.56-1.973043-1.08221-3.721068-2.531544-5.15-4.27-.763759-.19867-1.55093-.292861-2.34-.28Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M357.51,173.36c.305183-.023595.573372-.211327.7-.49c1.040163-2.338309,3.31326-3.887268,5.87-4c.421493-.061003.728417-.43112.710365-.856622s-.35522-.768292-.780365-.793378c-3.189311.147979-6.022124,2.08296-7.32,5-.111579.265259-.077796.569385.089274.803691s.443586.365354.730726.346309Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M346.28,150c2.211047.049216,4.359349.744459,6.18,2c1.381278.984028,2.520117,2.269923,3.33,3.76.563565,1.039545.964869,2.159149,1.19,3.32.083675.408208.45396.69337.87.67h.1c.225342-.035196.425405-.163762.551038-.354115s.165193-.424851.108962-.645885c-.23929-1.232564-.653476-2.424611-1.23-3.54c3.308817-1.067122,6.928862-.479283,9.73,1.58.475932.377738.908569.807022,1.29,1.28.383081.475696.718053.988203,1,1.53.605893-.043321,1.214107-.043321,1.82,0c2.279323.069536,4.468035.908367,6.21,2.38c1.919765,1.693729,3.136205,4.044562,3.41,6.59l.05.46.42.2c2.394663,1.130813,4.386854,2.966001,5.71,5.26.52.92,2.17,4.17,1.57,7.45-.124244.656055-.329132,1.29423-.61,1.9-1.445907,2.797468-3.880294,4.957407-6.83,6.06-1.93318.814267-3.987405,1.304173-6.08,1.45-.456322.037249-.79877.433065-.77.89s0,.05,0,.08c.079809.416194.457133.707763.88.68v0c3.588958-.223164,7.047871-1.426866,10-3.48c2.541621-1.697108,4.332163-4.307718,5-7.29.385659-2.966614-.234001-5.976897-1.76-8.55-1.405475-2.451235-3.488946-4.444422-6-5.74-.818257-5.969054-6.073401-10.315741-12.09-10v0v0c-.584555-.882496-1.299317-1.671432-2.12-2.34-3.06-2.46-7.4-3-11.66-1.75-1.470114-2.134025-3.56666-3.758848-6-4.65-.725679.053669-1.447163.153875-2.16.3l-.25.06h-.08l-.22.05h-.06c-.59.09-1.07.23-1.5.39Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.7,168.62c1.223948,1.583365,2.06581,3.427933,2.46,5.39.446361,2.290442.273763,4.658488-.5,6.86-.120556.415692.102727.853501.51,1c.105104.040282.217681.057339.33.05.334997-.019709.624177-.241546.73-.56c1.795827-5.077717.641887-10.732021-3-14.7Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.55,171.48c.517404.939424,1.213855,1.768371,2.05,2.44c1.159177.920069,2.537557,1.52311,4,1.75-.286028-.313859-.589863-.611016-.91-.89c0-.17.06-.43.08-.75.004963-.046535.004963-.093465,0-.14s0-.06,0-.09c-.797627-.250014-1.543103-.643083-2.2-1.16-.672293-.552908-1.229497-1.232425-1.64-2-.107326-.192373-.286723-.334189-.498675-.394211s-.439069-.033324-.631325.074211c-.191164.117094-.326053.307347-.373283.526491s-.002679.448069.123283.633509Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.49,208.12c.100899-.007845.19935-.035004.29-.08.199663-.089165.354794-.255268.430127-.46055s.064467-.432301-.030127-.62945c-.832056-2.099677-2.434557-3.802334-4.48-4.76-1.177449-.452771-2.445284-.620674-3.7-.49h-.58c-2.83,0-5.92-1.81-9.18-5.49-.304071-.34177-.827349-.373077-1.17-.07-.165949.142791-.267031.346675-.280218.565202s.062644.433088.210218.594798c3.59,4.06,7.1,6.09,10.44,6.05h.64c1.014397-.12513,2.044008-.001577,3,.36c1.660728.807482,2.956654,2.210509,3.63,3.93.138098.303818.446547.493633.78.48Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M337.18,201.61c.512698-.034619,1.01781-.142376,1.5-.32.786422-.282256,1.497889-.740604,2.08-1.34.233863-.206719.33198-.527164.253947-.829381s-.319022-.535105-.62373-.602764-.621612.041353-.820217.282145c-.40948.421889-.9084.746529-1.46.95-.834865.273325-1.735135.273325-2.57,0-.422991-.107034-.857502.127602-1,.54-.117633.424247.120739.865676.54,1c.674821.233057,1.386391.341486,2.1.32Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M336.63,190.05c.512698-.034619,1.01781-.142376,1.5-.32.78518-.284768,1.496115-.742774,2.08-1.34.275586-.334125.247926-.823987-.063521-1.124965s-.801968-.31188-1.126479-.025035c-.410972.420072-.909456.744428-1.46.95-.838268.273422-1.741732.273422-2.58,0-.290262-.117307-.621835-.061308-.857473.144818s-.335244.527304-.257589.830591.319359.537074.625062.604591c.689845.225022,1.415483.319965,2.14.28Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359.43,189.26c.241749-.015706.464571-.136248.61-.33.133171-.173885.190249-.394287.15822-.610954s-.150435-.411129-.32822-.539046c-3.622256-2.723984-8.695245-2.37471-11.91.82-.156969.154181-.245391.364975-.245391.585s.088422.430819.245391.585c.323696.321612.846304.321612,1.17,0c2.62517-2.630083,6.789738-2.916264,9.75-.67.1593.11536.353677.171906.55.16Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312,207.79c1.658318-.119935,3.286164-.508322,4.82-1.15.299268-.096924.518024-.354703.56497-.665753s-.085987-.621908-.343319-.802839-.594835-.200836-.871651-.051408c-1.634249.68699-3.387273,1.047108-5.16,1.06-2.742555-.004833-5.422118-.822622-7.7-2.35-.181009-.125458-.404876-.17283-.62119-.131448s-.406889.168038-.52881.351448c-.124038.180656-.169585.403861-.126246.618673s.171866.402896.356246.521327c2.546875,1.72543,5.553694,2.645245,8.63,2.64Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M311.26,197.7c.318672-.024195.596841-.225094.72-.52c1.94-4.82,4.73-8.32,8.27-10.42c1.500429-.865263,3.116749-1.511791,4.8-1.92c1.844327-.445876,3.608539-1.174499,5.23-2.16c3.78-2.37,6.61-6.32,8.41-11.74.099845-.419052-.137499-.844837-.546435-.980281s-.853522.064479-1.023565.460281c-1.68,5.05-4.28,8.71-7.73,10.87-1.489607.905657-3.108034,1.580002-4.8,2-1.818496.448027-3.56541,1.148139-5.19,2.08-3.86,2.29-6.88,6.07-9,11.23-.084747.202554-.083634.430834.003086.632552s.251614.359587.456914.437448c.128241.045641.266386.056002.4.03Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.18,178.28v0c.451425-.052334.776826-.45797.73-.91-.05861-.57746-.189639-1.145252-.39-1.69-.325911-.916531-.824965-1.761868-1.47-2.49-.304071-.34177-.827349-.373077-1.17-.07-.164953.142894-.266139.345648-.281154.563369s.057379.432446.201154.596631c.507167.570309.900872,1.23214,1.16,1.95.150483.426984.25115.869918.3,1.32.025081.218854.136133.418761.308696.555685s.392478.199634.611304.174315Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M318.31,187.59c.325621-.044736.595237-.275277.69-.59.177385-.551953.29145-1.122281.34-1.7.078736-.968341-.029912-1.942782-.32-2.87-.138505-.41577-.576379-.652222-1-.54-.423277.13014-.666762.572839-.55,1c.226804.727038.311678,1.490908.25,2.25-.031509.452356-.118838.89908-.26,1.33-.113219.420778.118226.857468.53,1c.097684.060763.206449.10155.32.12Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M349.19,201.8c.338673-.018423.630005-.245902.73-.57.177374-.555376.291431-1.129014.34-1.71.078194-.96504-.030457-1.936105-.32-2.86-.13531-.439066-.600934-.68531-1.04-.55s-.68531.600934-.55,1.04c.230126.722953.31841,1.483557.26,2.24-.039762.455336-.130325.904796-.27,1.34-.123284.424867.117121.870061.54,1c.096224.047858.202548.071866.31.07Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M334.74,181.86c.656938-.050031,1.30518-.181023,1.93-.39.278667-.094675.485658-.330826.543-.619497s-.043675-.586005-.265-.78-.529333-.255178-.808-.160503c-1.163507.394619-2.420112.422544-3.6.08-.4294-.110377-.869734.13621-1,.56-.058468.206872-.032301.4285.072737.616067s.280329.325686.487263.383933c.56415.160426,1.144374.257689,1.73.29.302632.02541.606544.032089.91.02Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M366.89,178.88c3.033214-.205781,5.989853-1.043722,8.68-2.46c4.208639-2.265413,7.569855-5.833635,9.58-10.17.091525-.200235.099745-.42863.022853-.634927s-.232598-.373592-.432853-.465073c-.417166-.184742-.905524-.002718-1.1.41-3.267797,7.196177-10.466869,11.79308-18.37,11.73-.316432-.034891-.62494.114282-.794098.383971s-.169159.612369,0,.882058.477666.418862.794098.383971q.81,0,1.62-.06Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.79,181.15v0c1.80773-.156857,3.424627-1.187488,4.33-2.76.61952-1.212148.744977-2.617272.35-3.92-.13014-.423277-.572839-.666762-1-.55-.423277.13014-.666762.572839-.55,1c.268326.889933.186035,1.8488-.23,2.68-.642833,1.070944-1.756474,1.772538-3,1.89-.452873.033137-.793137.427127-.76.88s.427127.793137.88.76Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M377.49,173.94c.411196-.018258.745142-.338519.780581-.748592s-.238613-.782876-.640581-.871408c-4.22-1-7.17-3.55-7.71-6.52-.145986-.862488-.101617-1.746465.13-2.59.108-.438315-.154115-.882577-.59-1-.437481-.102433-.878108.157536-1,.59-.287517,1.076292-.338689,2.202062-.15,3.3.65,3.62,4.07,6.62,8.94,7.83.078921.016382.159989.01976.24.01Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M360.86,189.75c.253672-.018434.485331-.150811.63-.36.529704-.790843,1.209157-1.470296,2-2c3.24-2.14,7.73-1.38,10.94-.37.280453.089316.587253.022228.80483-.175994s.312876-.497462.25-.785-.274377-.51969-.55483-.609006c-3.55-1.12-8.58-1.94-12.36.57-.978253.651563-1.820538,1.487055-2.48,2.46-.122259.180268-.167772.401771-.126499.61564s.165941.402531.346499.52436c.163139.104797.357205.150667.55.13Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.64,173.15c.276906-.019269.525267-.177316.66-.42c2.144151-3.059472,5.226158-5.33763,8.78-6.49c3.422325-1.13135,7.073844-1.385788,10.62-.74.216267.05067.443821.01254.631758-.10586s.320575-.307191.368242-.52414c.053565-.216459.016666-.445398-.102195-.634067s-.309433-.320794-.527805-.365933c-3.850892-.728505-7.824312-.456495-11.54.79-6.87,2.46-9.55,7-9.66,7.24-.111094.190421-.140833.417554-.082509.630157s.199801.392766.392509.499843c.139219.08193.2985.123481.46.12Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.59,207.64c.1766-.008551.345392-.075365.48-.19.347811-.298299.388097-.822016.09-1.17-1.370439-1.483058-2.090614-3.452736-2-5.47.111161-1.348737.573111-2.644953,1.34-3.76.25129-.383838.143838-.89871-.24-1.15s-.89871-.143838-1.15.24c-.925996,1.353157-1.481112,2.925408-1.61,4.56-.116372,2.44885.743117,4.84391,2.39,6.66.174051.201425.43505.305824.7.28Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.8,198.44c.385338-.019634.703339-.308345.76-.69.034408-.216333-.019172-.43744-.148793-.614025s-.324506-.293966-.541207-.325975c-5.28997-.815997-10.322314-2.834409-14.71-5.9-3.399532-2.380239-6.334581-5.362736-8.66-8.8-.261234-.378535-.778309-.476601-1.16-.22-.182765.120034-.309237.308859-.35067.523555s.005695.437023.13067.616445c2.442258,3.601543,5.518952,6.729064,9.08,9.23c4.595774,3.212638,9.867931,5.326975,15.41,6.18Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.79,215.11c.339305-.022694.631452-.247726.74-.57.117633-.424247-.120739-.865676-.54-1-1.767024-.574928-3.611858-.875093-5.47-.89-1.75791.022454-3.505613.271165-5.2.74l-.95.22c-2.778015.629674-5.599206,1.050847-8.44,1.26-.426705.066705-.730947.449496-.69962.880245s.387754.765491.81962.769755v0c2.921007-.222475,5.821982-.656953,8.68-1.3l1-.22c1.566752-.438303,3.18331-.673561,4.81-.7c1.698476.010408,3.385108.283642,5,.81.082844.012778.167156.012778.25,0Z",
  fill: "#c54342"
}), /*#__PURE__*/React.createElement("path", {
  d: "M375.93,197.86c.56,0,1.2.07,1.92.07h.71.49.26.79.31l.47-.05.44-.05h.27.07.27l1.07-.18c3.36-.65,8.27-1.58,11.7-5.67-.034386-.117089-.092225-.225962-.17-.32-.141841-.16849-.344833-.273696-.564278-.292452s-.437346.050477-.605722.192452c-1.748002,1.449338-3.702966,2.629058-5.8,3.5-3.482945,1.416748-7.257128,1.969151-11,1.61-.451818-.040738-.852642.288828-.9.74.036094.176384.131352.335148.27.45Z",
  fill: "#c54342"
})))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg505",
  transform: "matrix(2.68 0 0-2.68-3953.391455 2447.320542)",
  opacity: 0
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.211292 0 0 0.211292 1610.432896 861.575436)",
  fill: "url(#eZ2eP1AIHkg506-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.388996 0 0 0.388996 1590.049299 855.754001)",
  fill: "url(#eZ2eP1AIHkg507-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.154654 0 0 0.154654 1591.545657 830.603022)",
  fill: "url(#eZ2eP1AIHkg508-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.154654 0 0 0.154654 1617.609513 854.701674)",
  fill: "url(#eZ2eP1AIHkg509-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.154654 0 0 0.154654 1628.278111 841.869017)",
  fill: "url(#eZ2eP1AIHkg510-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.551149 0 0 0.551149 1603.331777 827.210698)",
  fill: "url(#eZ2eP1AIHkg511-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.237892 0 0 0.237892 1619.388173 829.687919)",
  fill: "url(#eZ2eP1AIHkg512-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.237892 0 0 0.237892 1585.911374 839.795788)",
  fill: "url(#eZ2eP1AIHkg513-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.509887 0 0 0.509887 1595.552641 843.596961)",
  fill: "url(#eZ2eP1AIHkg514-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.509887 0 0 0.509887 1611.880576 842.534783)",
  fill: "url(#eZ2eP1AIHkg515-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.509887 0 0 0.509887 1598.922825 850.87968)",
  fill: "url(#eZ2eP1AIHkg516-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.509887 0 0 0.509887 1609.612562 835.592741)",
  fill: "url(#eZ2eP1AIHkg517-fill)",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 3.846717,
  ry: 3.846717,
  transform: "matrix(.509887 0 0 0.509887 1596.961434 836.736401)",
  fill: "url(#eZ2eP1AIHkg518-fill)",
  strokeWidth: 0
})))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg519",
  transform: "matrix(0 0 0 0 1623.999004 973.075069)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "eZ2eP1AIHkg520",
  points: "54,78.86 54,89 64,83.93 74,89 74,78.86",
  fill: "none",
  stroke: "#43b85e",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg521",
  d: "M83,58c0,2.42-2.63,4.31-3.51,6.42s-.41,5.37-2.06,7-4.83,1.15-7,2-4.01,3.58-6.43,3.58-4.31-2.63-6.42-3.51-5.37-.41-7-2.06-1.15-4.83-2.05-7-3.53-4.01-3.53-6.43s2.63-4.31,3.51-6.42.41-5.37,2.06-7s4.83-1.15,7-2.05s4.01-3.53,6.43-3.53s4.31,2.63,6.42,3.51s5.37.41,7,2.06s1.15,4.83,2,7s3.58,4.01,3.58,6.43Z",
  opacity: 0,
  fill: "#5483cc",
  stroke: "#5483cc",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg522",
  d: "M81,58c0,2.42-.63,4.31-1.51,6.42s-1.824214,3.955786-3.474214,5.585786-3.415786,2.564214-5.585786,3.414214-4.01,1.58-6.43,1.58-4.31-.63-6.42-1.51-3.955786-1.824214-5.585786-3.474214-2.564214-3.415786-3.464214-5.585786-1.53-4.01-1.53-6.43.63-4.31,1.51-6.42s1.824214-3.955786,3.474214-5.585786s3.415786-2.564214,5.585786-3.464214s4.01-1.53,6.43-1.53s4.31.63,6.42,1.51s3.955786,1.824214,5.585786,3.474214s2.564214,3.415786,3.414214,5.585786s1.58,4.01,1.58,6.43Z",
  transform: "matrix(0 1-1 0 122-6)",
  fill: "#6ace81",
  stroke: "#43b85e",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  id: "eZ2eP1AIHkg524",
  d: "M81,58c0,2.42-.63,4.31-1.51,6.42s-1.824214,3.955786-3.474214,5.585786-3.415786,2.564214-5.585786,3.414214-4.01,1.58-6.43,1.58-4.31-.63-6.42-1.51-3.955786-1.824214-5.585786-3.474214-2.564214-3.415786-3.464214-5.585786-1.53-4.01-1.53-6.43.63-4.31,1.51-6.42s1.824214-3.955786,3.474214-5.585786s3.415786-2.564214,5.585786-3.464214s4.01-1.53,6.43-1.53s4.31.63,6.42,1.51s3.955786,1.824214,5.585786,3.474214s2.564214,3.415786,3.414214,5.585786s1.58,4.01,1.58,6.43Z",
  transform: "matrix(0 1.117647-1.117647 0 128.823526-13.529408)",
  fill: "#83da97",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "eZ2eP1AIHkg525",
  rx: 17,
  ry: 17,
  transform: "translate(64 58)",
  fill: "#83da97",
  stroke: "#83da97",
  strokeWidth: 0
}), /*#__PURE__*/React.createElement("polyline", {
  id: "eZ2eP1AIHkg526",
  points: "55.25,58 60.8,63.97 72.75,52.03",
  opacity: 0,
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeDashoffset: 25.04,
  strokeDasharray: 25.4
}))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.943575 0 0 0.943572 53.10673 784.979318)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg529",
  transform: "matrix(0 0 0 0 119.700131 162.26877)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.2,
  ry: 11.2,
  transform: "translate(25.2 11.2)",
  fill: "#5872ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2,4.9c12,0,22,3.8,24.5,8.8.429486-.765535.669506-1.622747.7-2.5C50.4,5,39.1,0,25.2,0C11.3,0,0,5,0,11.2c-.004189.869486.201645,1.727125.6,2.5c2.5-5,12.6-8.8,24.6-8.8Z",
  fill: "#1337ff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg533",
  transform: "matrix(0 0 0 0 119.7 164.099999)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.8,
  height: 101.741044,
  rx: 3,
  ry: 3,
  transform: "matrix(1 0 0 1.014866 114.3 69.992064)",
  fill: "url(#eZ2eP1AIHkg534-fill)"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg535"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0,62.6 8.2,56.1 9.6,64.3 0,62.6",
  fill: "url(#eZ2eP1AIHkg536-fill)"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0,19.8 3.5,15 218.5,0 263,50.9 263.8,53.8 216.5,6.9 0,19.8",
  fill: "#5a9dff"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0,19.8 218,3.2 263.8,53.8 206.8,97.3 4.5,91.2 0,62.6 8.9,63.1 0,19.8",
  fill: "url(#eZ2eP1AIHkg538-fill)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.637568,854.63752l227.465313-7.902196.454546.522428-227.746817,8.181734-.173042-.801966Z",
  transform: "matrix(1.119142 0 0 1.136023-110.635325-908.705263)",
  opacity: 0.5,
  fill: "#2575fc",
  strokeWidth: 3.84
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg540"
}, /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Inter",
  fontSize: 27,
  fontWeight: 600,
  transform: "matrix(1.179336-.039588 0.039588 1.179336 76.244048 52.269767)",
  fill: "#fff",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 600,
  strokeWidth: 0
}, "200+"), /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 27,
  fontWeight: 600,
  strokeWidth: 0
})), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Inter",
  fontSize: 18,
  fontWeight: 600,
  transform: "matrix(1.179682-.027389 0.027389 1.179682 21.503284 80.100059)",
  fill: "#fff",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 600,
  strokeWidth: 0
}, "Interview Problems")))))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-.943575 0 0 0.943572 1856.612802 427.24776)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg548",
  transform: "matrix(0 0 0 0 119.700131 162.26877)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
  rx: 25.2,
  ry: 11.2,
  transform: "translate(25.2 11.2)",
  fill: "#5872ff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2,4.9c12,0,22,3.8,24.5,8.8.429486-.765535.669506-1.622747.7-2.5C50.4,5,39.1,0,25.2,0C11.3,0,0,5,0,11.2c-.004189.869486.201645,1.727125.6,2.5c2.5-5,12.6-8.8,24.6-8.8Z",
  fill: "#1337ff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg552",
  transform: "matrix(0 0 0 0 119.7 164.099999)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 10.8,
  height: 102.800846,
  rx: 3,
  ry: 3,
  transform: "matrix(-1 0 0 0.996501 125.10001 70.890847)",
  fill: "url(#eZ2eP1AIHkg553-fill)"
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg554"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "0,62.6 8.2,56.1 9.6,64.3 0,62.6",
  fill: "url(#eZ2eP1AIHkg555-fill)"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0,19.8 3.5,15 218.5,0 263,50.9 263.8,53.8 216.5,6.9 0,19.8",
  fill: "#5a9dff"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "0,19.8 218,3.2 263.8,53.8 206.8,97.3 4.5,91.2 0,62.6 8.9,63.1 0,19.8",
  fill: "url(#eZ2eP1AIHkg557-fill)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.637568,854.63752l227.465313-7.902196.454546.522428-227.746817,8.181734-.173042-.801966Z",
  transform: "matrix(1.119142 0 0 1.136023-110.635325-908.705263)",
  opacity: 0.5,
  fill: "#2575fc",
  strokeWidth: 3.84
}), /*#__PURE__*/React.createElement("g", {
  id: "eZ2eP1AIHkg559",
  transform: "matrix(-1 0 0 1 247.888306 0)"
}, /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Inter",
  fontSize: 18,
  fontWeight: 600,
  transform: "matrix(1.185369 0.032094-.032094 1.185369 30.482864 44.317373)",
  fill: "#fff",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 600,
  strokeWidth: 0
}, "Data Structures &")), /*#__PURE__*/React.createElement("text", {
  dx: 0,
  dy: 0,
  fontFamily: "eZ2eP1AIHkg1:::Inter",
  fontSize: 18,
  fontWeight: 600,
  transform: "matrix(1.184973 0.044352-.044352 1.184973 65.174515 73.052174)",
  fill: "#fff",
  strokeWidth: 0
}, /*#__PURE__*/React.createElement("tspan", {
  y: 0,
  fontWeight: 600,
  strokeWidth: 0
}, "Algorithms"))))))))));
export default __webpack_public_path__ + "static/media/Learning-Path.33193858.svg";
export { SvgComponent as ReactComponent };